import {
  InputLabel,
  FormGroup,
  Paper,
  TextField,
  Table,
  TableHead,
  TableRow,
  Typography,
  FormControl,
  Button,
  MenuItem,
  Select,
  FormControlLabel,
  Checkbox,
  Modal,
  Dialog,
  ListSubheader,
  FormHelperText,
  TableCell
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GetRole from "./user";
import { useState, useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { fetchTripbyId, fetchCustomerbyId, sendmailtoteam } from "../api/customerapi";
import { updateTripdata, gmailSend, fetchSuppliers, fetchEmployeebyName, addTask, getsupplierbookingrecord } from "../api/customerapi";
import DateCalc, {total as totalfromdatejs, sptotal as sptotalfromdatejs,paymentdate, identifydest, DateCalc2, getprofit, getconvdate, removeDuplicates, airlinelist, waiveofftotal, getcomment, getmaillist, getempTL, reversesortByKey} from "./date.js"
import { init } from "@emailjs/browser";

const useStyles = makeStyles((theme) => ({
  paper: (props)=>({
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(10),
    justifyContent: "center",
    backgroundColor: props.bgColor || "#f8f8f8", // default fallback
    transition: "background-color 0.5s ease", // smooth transition
  }),
  modalText: {
    marginLeft: theme.spacing(30),
    marginRight: theme.spacing(4),
    width: theme.spacing(120),
    marginTop: theme.spacing(10),
    marginBottom: theme.spacing(2),
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f8f8f8",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(50),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField3: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(10),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textFieldnew: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  textField2: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(30),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
   textField4: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(15),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  headertext: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  formgroup: {
    justifyContent: "center",
  },
  textArea: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
   textAreanew: {
    marginLeft: theme.spacing(12),
    marginRight: theme.spacing(14),
    width: theme.spacing(190),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    width: theme.spacing(18),
    height: theme.spacing(4),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button2: {
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    width: theme.spacing(20),
    height: theme.spacing(5),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const Trippaymentupdate = () => {
  const [bgColor, setBgColor] = useState("#f8f8f8");
  const classes = useStyles({ bgColor });
  const currenturl = window.location.href;
  const urlarray = currenturl.split("/");
  const currentid = urlarray[urlarray.length - 2];
  const [sData, setsData] = useState([{all_good:false}]);
  const [empops, setempops] = useState([]);
  const [emplist, setemplist] = useState([]);
  const [cpdata, setcpdata] = useState([]);
  const [custData, setcustData] = useState([]);
  const [tripData, settripData] = useState({});
  const [upsellData, setupsellData] = useState([]);
  const [changelog, setchangelog] = useState([]);
  const [spdata, setspdata] = useState([]);
  const [hoarr, sethoarr] = useState([]);
  const [oldspdata, setoldspdata] = useState([]);
  const [notax, setnotax] = useState(0);
  const [oldvisacost, setoldvisacost] = useState(false);
  const [allclear, setallclear] = useState(0);
  const [tcsmail, settcsmail] = useState(0);
  const [fp, setfp] = useState(0);
  const [onhold, setonhold] = useState(0);
  const [holdops, setholdops] = useState(0);
  const [fdom, setfdom] = useState(0);
  const [hightcs, sethightcs] = useState(0);
  const [fivetcs, setfivetcs] = useState(0);
  const [confirmation, setconfirmation] = useState(0);
  const [oldprofit, setoldprofit] = useState(0);
  const [schedule, setschedule] = useState(false);
  const [open2, setopen2] = useState(false);
  const [onlyflight, setonlyflight] = useState(0);
  const [modal, setmodal]=useState(false);
  const [loadtime, setloadtime] = useState(null);
  const [upsellpitch, setupsellpitch] = useState({
        tour:false,
        hotel:false,
        insurance:false,
        sim:false,
        ac:false,
        visa:false,
        others:false,
  });
  const [selectedFile, setSelectedFile] = useState();
  const [selectedFile2, setSelectedFile2] = useState();
  const [isSelected, setIsSelected]= useState(false)
  const [supplierexisted, setsupplierexisted]= useState(false)
  const [showcl, setshowcl]= useState(false)
  const [findata, setfindata] = useState({total:0, upselltotal:0, upsellcosttotal:0, costtotal:0});
  const { cuser, role, employeelist, destinationlist, loading } = GetRole();
  const airlinelist2=airlinelist.sort()
  const originalValueRef = useRef({});
  const addcp = () => {
    //console.log(count)

    setcpdata(
      cpdata.length == 0 ? [{ id: uuidv4() }] : [...cpdata, { id: uuidv4() }]
    );
  };

  const removecp = () => {
    setcpdata([...cpdata].slice(0, cpdata.length - 1));
  };

  const addmid =(index) =>{
    var currentprofit=getprofit({...tripData})
    var temp2=[...cpdata]
    temp2.splice(index+1, 0, {id:uuidv4(), status:"Pending"});
    var changeobj={entity:"New Tranche", old_value:null, new_value:null, changed_by:cuser, changed_date:new Date(), tranche:index, old_profit:currentprofit,
      new_profit:getprofit({...tripData, cust_payments:temp2})}
    //console.log(temp2)
    setcpdata(temp2)
    setchangelog([...changelog, changeobj])
    //setdaydata(daydata.length==0? [{id:uuidv4()}]: [...daydata,{id:uuidv4()}]) 
}

const removemid =(index) =>{
   var currentprofit=getprofit({...tripData})
  var temp2=[...cpdata]
  var temp3=temp2.filter(item=>item.id==index.id)
  if(!(role=="Accounts") && temp3.length>0 && temp3[0].status!=="Pending"){
      alert("Cannot delete this tranche")
  }else{
      temp2=temp2.filter(item=>item.id!==index.id)
  }
   var changeobj={entity:"Deleted Tranche", old_value:temp3[0].amount, changed_by:cuser, changed_date:new Date(), old_profit:currentprofit, new_profit:getprofit({...tripData, cust_payments:temp2})}
  
  //console.log(temp2)
  setcpdata(temp2)
  setchangelog([...changelog, changeobj])
    //setdaydata([...daydata].filter(item=>item.id!==index.id))
}

  const addsp = () => {
    //console.log(spdata)

    setspdata(
      spdata.length == 0 ? [{ id: uuidv4(), responsible:cuser, checker:"Kaushal", name:"Not Booked Yet" }] : [...spdata,  { id: uuidv4(), responsible:cuser, checker:"Kaushal", name:"Not Booked Yet"}]
    );
  };

  const removesp = () => {
      var currentprofit=getprofit({...tripData})
  if(!(role=="Accounts") && spdata.length>0 && spdata[spdata.length-1].status!=="Pending"){
      alert("Cannot delete this tranche")
  }else{
       
        var changeobj={entity:"SP-Deleted Tranche", old_value:spdata[spdata.length-1].amount, changed_by:cuser, changed_date:new Date(), old_profit:currentprofit, new_profit:getprofit({...tripData, supplier_payments:[...spdata].slice(0, spdata.length - 1)})}
        setchangelog([...changelog, changeobj])
        setspdata([...spdata].slice(0, spdata.length - 1));
  }
    //console.log(spdata)
   
  };

  var oldspdata2=[]
  const getTrips = async (id) => {
    try{
    const data = await fetchTripbyId(id);
    settripData({...data.data, supplier_payment_note:getcomment(data.data, "Ops", 1)});
    setnotax(data.data.no_tax)
    setonlyflight(data.data.only_flight)
    setfdom(data.data.no_tcs)
    sethightcs(data.data.hightcs)
    setoldvisacost(data.data.visa_sp)
    setfivetcs(data.data.five_tcs)
    setallclear(data.data.all_clear)
    sethoarr(data.data.hold_ops_array)
    setchangelog(data.data.changelog ? data.data.changelog : [])
    if(data.data.hold_ops){
      setallclear(false)
    }
    settcsmail(data.data.tcs_mail)
    setfp(data.data.freeze_profit)
    setholdops(data.data.hold_ops)
    setonhold(data.data.on_hold)
    setupsellData(data.data.upsell)
    setupsellpitch(data.data.upsell_pitch)
    setcpdata(data.data.cust_payments ? data.data.cust_payments : []);
    var loadtotal=totalfromdatejs(data.data.cust_payments)
    var loadupselltotal=upselltotal(data.data.upsell)
    var loadcosttotal=sptotalfromdatejs(data.data.supplier_payments)
    var loadupsellcosttotal=upsellcosttotal(data.data.upsell)
    setfindata({total:loadtotal, upselltotal:loadupselltotal, upsellcosttotal:loadupsellcosttotal, costtotal:loadcosttotal})
    if(oldspdata.length>0){
    
    //oldspdata2=data.data.supplier_payments ? data.data.supplier_payments : []
    }else{
      console.log("Here")
      setoldspdata(data.data.supplier_payments ? [...data.data.supplier_payments] : []);
    }
    setspdata(data.data.supplier_payments ? data.data.supplier_payments : []);
    setloadtime(new Date())
    const temp=getprofit(data.data)
    setoldprofit(temp)
    if("supplier_payments" in data.data && data.data.supplier_payments.length>0){
      setsupplierexisted(true)
    }
    const data4 = await fetchCustomerbyId(data.data.cust_id);
    setcustData(data4.data);
  }catch(err){
    console.log(err)
  }
  };
  const getsuppliers = async () => {
    try{
    //console.log(tripData.primary_destination)
    //const data = await fetchSuppliersbyDest(tripData.primary_destination);
    const data = await fetchSuppliers();
    var data2=data.data.filter(sup=>sup.supplier_destinations==tripData.primary_destination || sup.supplier_destinations=="All")
    if(tripData.secondary_destinations){
      const data3=data.data.filter(sup=>sup.supplier_destinations==tripData.secondary_destinations)
      data2=data2.concat(data3)
      //console.log(data3)
      //console.log(data2)
    }
    let sortedSuppliers = data2.sort((a, b) => {
      if (a.supplier_name < b.supplier_name) {
          return -1;
      }
      if (a.supplier_name > b.supplier_name) {
          return 1;
      }
      return 0;
  });;
        setsData(sortedSuppliers)
      }catch(err){
        console.log(err)
      }
  };

  const getEmployees = async () => {
    try{
    //const data = await fetchEmployees();
    //const custdatalistfromdb= data.data
    setemplist(employeelist)
   
    const empsplist2 = employeelist.filter((emp) => emp.role == "TL" || emp.role=="Operations" || emp.role=="Operations-TL" || emp.role=="Product" || emp.role == "SME" );
    const empshortname2 = empsplist2.map((emp) => emp.short_name);
    setempops(empshortname2)
  }catch(err){
    console.log(err)
  }
  };

  useEffect(() => {
    getTrips(currentid);
    //getEmployees()
  }, []);

  useEffect(() => {
      if (!loading) {
        console.log("User:", cuser);
        console.log("Role:", role);
        console.log("Employees:", employeelist.length);
        console.log("Destinations:", destinationlist.length);
        getEmployees();
        //getDest()
      }
    }, [loading, cuser, role, employeelist, destinationlist]);

  useEffect(() => {

    getsuppliers();
    var z=gettcs2()
    var x=gettcs()
    var y=gettaxes()
    console.log(x,y,z)
  }, [tripData]);

   

   useEffect(() => {
    if(onlyflight){
      setBgColor("rgb(181, 181, 255)")
    }
    if(notax && fdom){
      
      setBgColor("#fdeaebff")
    }else if(notax && !fdom){
        setBgColor("#faeeefff")
      
    }else if(fdom && !notax){
        setBgColor("#e9f7e9ff")
    }else{
      setBgColor("#f8f8f8ff")
    }
    
  }, [notax, fdom, onlyflight]);

  //console.log(spdata);
  let nd=DateCalc2(tripData.trip_start_date,7)
  var fupsomeDate = new Date(nd);
  
  fupsomeDate.setDate(fupsomeDate.getDate()); 
  const fupy=fupsomeDate.getFullYear()
  const fupm=(fupsomeDate.getMonth()+1) < 10? ("0"+(fupsomeDate.getMonth()+1)) : (fupsomeDate.getMonth()+1)
  const fupdt=fupsomeDate.getDate() <10 ? ("0"+fupsomeDate.getDate()) : fupsomeDate.getDate()
  const fupfinalDate2=(fupy+"-"+fupm+"-"+fupdt)

  const datechange = (e, tid, id) => {
    
    const newdata = cpdata[tid];
    var changeobj={entity:"Date", old_value:newdata.date, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //console.log(newdata)
    const newitem = { ...newdata, date: e.target.value, last_updated_by:cuser, last_updated_time:new Date() };
    //console.log(newitem)
    setcpdata(cpdata.map((item) => (item.id == id ? newitem : item)));
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

  const amountchange = (e, tid, id) => {
    const newdata = cpdata[tid];
    //var changeobj={entity:"Amount", old_value:newdata.amount, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //console.log(id)
    const newitem = { ...newdata, amount: e.target.value, last_updated_by:cuser, last_updated_time:new Date() };
    //console.log(newitem)
    //cpdata[tid]=newitem
    // const newcpdata=cpdata.filter(item => item.id !=id)
    // setcpdata([...newcpdata, newitem])
    setcpdata(cpdata.map((item) => (item.id == id ? newitem : item)));
    //setchangelog([...changelog, changeobj])
    //console.log(cpdata[tid])
  };

  // field -> which data array/key it edits, the changelog entity name, and whether it's numeric
  const blurfields = {
    "CP-Amount": { data: () => cpdata, key: "amount", entity: "Amount", numeric: true },
    "SP-Amount": { data: () => spdata, key: "amount", entity: "Supplier-Amount", numeric: true },
    "SP-Value": { data: () => spdata, key: "currency_value", entity: "Supplier-Currency Value", numeric: true },
    "SP-Details": { data: () => spdata, key: "details", entity: "Supplier-Details", numeric: false },
  };

  const handleBlur = (e, tid, id, field) => {
    var currentprofit=getprofit({...tripData})
  const config = blurfields[field];
  const refkey = field + "-" + tid; // cp and sp tranches share tids, so key by field too
  if (!config || !(refkey in originalValueRef.current)) return;

  const oldValue = originalValueRef.current[refkey];
  const newValue = config.numeric ? Number(e.target.value) : e.target.value;
  const changed = config.numeric
    ? Number(oldValue || 0) !== newValue
    : (oldValue || "") !== newValue;

  if (changed) {
    const changeobj = {
      entity: config.entity,
      old_value: oldValue,
      new_value: newValue,
      changed_by: cuser,
      changed_date: new Date(),
      tranche: tid,
      old_profit:currentprofit,
      new_profit:getprofit({...tripData, cust_payments:cpdata, supplier_payments: spdata})
    };
    setchangelog((prev) => [...(prev || []), changeobj]);
  }

  delete originalValueRef.current[refkey]; // reset so next edit session captures fresh
};
console.log(changelog)

const handleFocus = (tid, field) => {
  const config = blurfields[field];
  const refkey = field + "-" + tid;
  // Only capture it the first time — don't overwrite if already focused/editing
  if (config && !(refkey in originalValueRef.current)) {
    const row = config.data()[tid];
    originalValueRef.current[refkey] = row ? row[config.key] : undefined;
  }
};

  const statuschange = (e, tid, id) => {
    if(role!=="Accounts" && !(e.target.value=="Pending" || e.target.value=="Refund Due" || e.target.value=="Internal Refund")){
      alert("Only Accounts have access to mark payment")
    }else{
    const newdata = cpdata[tid];
    var changeobj={entity:"Status", old_value:newdata.status, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    let mailflag=0
    const newitem = { ...newdata, status: e.target.value, last_updated_by:cuser, last_updated_time:new Date() };
    //console.log(newitem)
    setcpdata(cpdata.map((item) => (item.id == id ? newitem : item)));
    setchangelog([...changelog, changeobj])
    if(e.target.value=="Received" && spdata.length>0 && "booking" in tripData && "ops_assigned" in tripData.booking){
      for(let i=0;i<spdata.length;i++){
        if(spdata[i].supplier_type=="Hotel Portal" && spdata[i].status=="Pending"){
          mailflag=1
        }
      }
    }
    if(mailflag){
      const finalarray={
        to:["operationsteam@jetovacations.com", "debayan.ghosh@jetovacations.com"],
        sub:"Payment Received for Trip Id: "+tripData.trip_id+".Recheck hotels"+tripData.booking.ops_assigned,
        body:"Payment Received for Trip Id: "+tripData.trip_id+".Recheck hotels to save money",
      }
      const data=sendmailtoteam(finalarray)
    }
  }
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const modechange = (e, tid, id) => {
    const newdata = cpdata[tid];
    var changeobj={entity:"Mode", old_value:newdata.mode, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //console.log(newdata)
    const newitem = { ...newdata, mode: e.target.value, last_updated_by:cuser, last_updated_time:new Date() };
    //console.log(newitem)
    setcpdata(cpdata.map((item) => (item.id == id ? newitem : item)));
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const accountchange = (e, tid, id) => {
    const newdata = cpdata[tid];
    var changeobj={entity:"Account", old_value:newdata.account, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //console.log(newdata)
    const newitem = { ...newdata, account: e.target.value, last_updated_by:cuser, last_updated_time:new Date() };
    //console.log(newitem)
    setcpdata(cpdata.map((item) => (item.id == id ? newitem : item)));
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };
  const detailschange = (e, tid, id) => {
    const newdata = cpdata[tid];
    //var changeobj={entity:"Details", old_value:newdata.details, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //console.log(newdata)
    const newitem = { ...newdata, details: e.target.value, last_updated_by:cuser, last_updated_time:new Date() };
    //console.log(newitem)
    setcpdata(cpdata.map((item) => (item.id == id ? newitem : item)));
    //setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const spdatechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, date: e.target.value };
    //console.log(newitem)
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Date", old_value:newdata.date, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

   const spbookingdatechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, booking_date: new Date(e.target.value) };
    //console.log(newitem)
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Booking Date", old_value:newdata.booking_date, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

   const spcutoffchange = (e, tid, id) => {
    if(e.target.value!==null){
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, cut_off: e.target.value };
    //console.log(newitem)
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
     var changeobj={entity:"Supplier-Cut Off", old_value:newdata.cut_off, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    }
    //setdata([...data, data[tid]=newitem])
    // console.log(cpdata)
  };

  const spamountchange = (e, tid, id) => {
    const newdata = spdata[tid];
    console.log(tid)
    const newitem = { ...newdata, amount: e.target.value };
    console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    //var changeobj={entity:"Supplier-Amount", old_value:newdata.amount, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata[tid])
  };

  const spstatuschange = (e, tid, id) => {
    console.log(e)
    const newdata = spdata[tid];
    var newitem={}
    //console.log(e.target)
    if(e.target.value=="Paid" || e.target.value=="Paid by internal team"){
      newitem = { ...newdata, status: e.target.value, date:DateCalc(0)};
    }else{
      newitem = { ...newdata, status: e.target.value };
    }
    if(e.target.value=="Refund Due"){
      alert("If customer will get refund due to this, create a Refund Due tranche for customer with the same value. It will be altered later by CX team")
    }
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Status", old_value:newdata.status, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const spinvoicechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(e.target)
    const newitem = { ...newdata, invoice: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Invoice", old_value:newdata.invoice, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const spmodechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, mode: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Mode", old_value:newdata.mode, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const spaccountchange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, account: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Account", old_value:newdata.account, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };
  const spdetailschange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, details: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    //var changeobj={entity:"Supplier-Details", old_value:newdata.details, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    //setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const currencychange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, currency: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const currencyvaluechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, currency_value: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const spairlinechange = (e, tid, id) => {
    console.log(e)
    const newdata = spdata[tid];
    console.log(newdata)
    const newitem = { ...newdata, airline_name: e.target.value };
    console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Airline", old_value:newdata.airline, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const spnamechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(e)
    //console.log(tid, id)
    var newitem = {  };
    if(e.target.value!=="Not Booked Yet"){
      newitem = { ...newdata, name: e.target.value, booking_date:new Date() };
    }else{
      newitem = { ...newdata, name: e.target.value };
    }
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Name", old_value:newdata.name, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    
  };

  const responsiblechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(e)
    //console.log(tid, id)
   
    // if("checker" in newdata && newdata.checker==e.target.value){
    //   alert("Responsible and Checker cannot be same")
    // }else{
    const newitem = { ...newdata, responsible: e.target.value };
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));

    //setdata([...data, data[tid]=newitem])
    //}
  };

  const checkerchange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(e)
    //console.log(tid, id)
    
    // if("responsible" in newdata && newdata.responsible==e.target.value){
    //   alert("Responsible and Checker cannot be same")
    // }else{
      const newitem = { ...newdata, checker: e.target.value };
      setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
   // }
    
    //setdata([...data, data[tid]=newitem])
    
  };

  const doublecheckchange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(e)
    //console.log(tid, id)
    
    // if("responsible" in newdata && newdata.responsible==e.target.value){
    //   alert("Responsible and Checker cannot be same")
    // }else{
      const newitem = { ...newdata, all_good: e.target.checked };
      setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
   // }
    
    //setdata([...data, data[tid]=newitem])
    
  };

  const pnachange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(e)
    //console.log(tid, id)
    
    // if("responsible" in newdata && newdata.responsible==e.target.value){
    //   alert("Responsible and Checker cannot be same")
    // }else{
      const newitem = { ...newdata, pna: e.target.checked };
      setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
   // }
    
    //setdata([...data, data[tid]=newitem])
    
  };
  //console.log(findata)

  const sptypechange = (e, tid, id) => {
    const newdata = spdata[tid];
    //console.log(newdata)
    const newitem = { ...newdata, businesstype: e.target.value };
    //console.log(newitem)
    spdata[tid] = newitem;
    setspdata(spdata.map((item) => (item.id == id ? newitem : item)));
    var changeobj={entity:"Supplier-Business Type", old_value:newdata.businesstype, new_value:e.target.value, changed_by:cuser, changed_date:new Date(), tranche:tid}
    setchangelog([...changelog, changeobj])
    //setdata([...data, data[tid]=newitem])
    //console.log(cpdata)
  };

  const checkbooking=()=>{
    var x=0
    for(let i=0;i<spdata.length;i++){
      // console.log(oldspdata[i].name)
      // console.log(getsuppliertype(spdata[i].name))
      // console.log(spdata[i].name)
      if(oldspdata[i] && oldspdata[i].name=="Not Booked Yet" && getsuppliertype(spdata[i].name)=="DMC" && oldspdata[i].name!==spdata[i].name){
        x=spdata[i].name
      }
    }
    console.log(x)
    return x
  }

  const handleSubmit = async (e) => {
    try{
      if(e){
    e.preventDefault();
      }

    let flag=0
    if(role !=="Admin" && spdata.length>0 && new Date(tripData.status_history[tripData.status_history.length-1]).getTime()>new Date("2023-09-01").getTime()){
      for(let i=0; i<spdata.length; i++){
        if(spdata[i].checker && spdata[i].responsible && spdata[i].checker==spdata[i].responsible){
          alert("Responsible and Checker cannot be same")
          flag=1
          return
        }
      }
    }
    if((new Date().getTime()-loadtime.getTime())>(60*1000*15)){
  
      alert("Trip Id is open for more than 30 minutes. Kindly reload the page")
      return
      // if(temp!=="1"){
      //   temp3=1
      // }
    }
    //if upsell total is changed then it should match with chang it total value as well
    
    console.log(findata, upselltotal(upsellData), upsellcosttotal(upsellData))
    if(findata.upselltotal!==upselltotal(upsellData) && findata.upselltotal - upselltotal(upsellData) !== findata.total - total()){
      
      alert("Upsell sales value change and total value change does not match")
      return
    }

    if(findata.upsellcosttotal !== upsellcosttotal(upsellData) && findata.upsellcosttotal - upsellcosttotal(upsellData) !== findata.costtotal - sptotal()){
      
      alert("Upsell cost value change and total value change does not match")
      return
    }
    if(oldvisacost && tripData.visa_sp !== oldvisacost){
      alert("Visa price changed. Inform Ops accordingly")
      const finalarray={
        to:["operations@jetovacations.com", "abhishek.sharma@jetovacations.com", "ops4@jetovacations.com", "ops7@jetovacations.com"],
        sub:"Trip Id: "+tripData.trip_id+" - visa SP changed",
        body:"Trip Id: "+tripData.trip_id+" - reconfirm visa details",
      }
      const data=sendmailtoteam(finalarray)
    }

    if (
      parseInt(tripData.flight_sp) +
        parseInt(tripData.visa_sp) +
        parseInt(tripData.anc_sp) +
        parseInt(tripData.extra_sp) +
        parseInt(tripData.cruise_sp) +
        parseInt(tripData.land_sp) + gettcs() + (tripData.high_tax_amount?parseInt(tripData.high_tax_amount):0)  !==
      total() + waiveofftotal(cpdata)
    ) {
      console.log(gettcs())
      console.log(waiveofftotal(cpdata))
      console.log(total())
      console.log(parseInt(tripData.flight_sp) +
        parseInt(tripData.visa_sp) +
        parseInt(tripData.anc_sp) +
        parseInt(tripData.extra_sp) +
        parseInt(tripData.cruise_sp) +
        parseInt(tripData.land_sp))
      alert("Sum of customer payments do not match");
    } else if (
      parseInt(tripData.flight_cp) +
        parseInt(tripData.visa_cp) +
        parseInt(tripData.anc_cp) +
        parseInt(tripData.extra_cp) +
        parseInt(tripData.cruise_cp) +
        parseInt(tripData.land_cp) !==
      sptotal()
    ) {
      alert("Sum of supplier payments do not match");
      
    } 
    
    else {
      let x=1
      var totpax="number_child" in tripData?Number(tripData.number_adults)+Number(tripData.number_child):Number(tripData.number_adults)
      var templand=tripData.flight_sp+tripData.visa_sp+totpax*3000
      for(let i = 0; i <cpdata.length-1; i++) {
        if(i>0 && new Date(cpdata[i].date).getTime()<new Date(cpdata[i-1].date).getTime()){
          x=0
          alert("Final installment date should be greater than previous dates. Installment dates should be in sequence");
        }
        
        if(i==1 && new Date(DateCalc(7)).getTime()-new Date(getconvdate(tripData)).getTime()<1000*60*60*24*7 && (role=="Sales"|| role=="TL") && new Date(cpdata[i].date).getTime()-new Date(cpdata[i-1].date).getTime()>1000*60*60*24*7 && cpdata[i].amount<templand){
          x=0
          alert("Second installment should be within 7 days of first installment and should cover the profit amount and the hotel amount");
        }
      }
      if(new Date(getconvdate(tripData)).getTime()>new Date("2025-07-01").getTime()){
         for(let i = 0; i <spdata.length; i++) {
            if(getsuppliertype(spdata[i].name)=="Hotel Portal" || getsuppliertype(spdata[i].name)=="Hotel" ){
              if("cut_off" in spdata[i] && spdata[i].cut_off){

              }else{
                x=0
                alert("Cut off date not found. Cannot proceed")
              }
            }
            if(getsuppliertype(spdata[i].name)=="Flight"){
            if("airline_name" in spdata[i] && spdata[i].airline_name){

              }else{
                x=0
                alert("Airline name not found. Cannot proceed")
              }
            }
         }
        }
      var receivedtillnow=total()-pending()
      var paidtillnow=sptotal()-sppending()
      if(receivedtillnow<paidtillnow){
        alert("You are paying more than amount received")
      }
      var y=checkbooking()
      // var lbd="land_booking_date" in tripData?tripData.land_booking_date:null
      if(x){
       
     if(y){
      // lbd=new Date()
      const finalarray={
        to:["debayan.ghosh@jetovacations.com", "product@jetovacations.com", "product2@jetovacations.com", "operations@jetovacations.com", "amit.singh@jetovacations.com"],
        sub:"Trip Id: "+tripData.trip_id+" for "+tripData.primary_destination+" confirmed with "+y,
        body:"Trip Id: "+tripData.trip_id+" for "+tripData.primary_destination+" confirmed with "+y,
      }
      const data=sendmailtoteam(finalarray)
     }
     let holdopsmarked=0
     let holdopsdate="hold_ops_date" in tripData && tripData.hold_ops_date?tripData.hold_ops_date:null
     if(!("hold_ops" in tripData && tripData.hold_ops) && holdops){
      holdopsmarked=1
      holdopsdate="hold_ops_date" in tripData && tripData.hold_ops_date?tripData.hold_ops_date:new Date()
      var tempemp=emplist.filter(e=>e.short_name==tripData.trip_owner)
      const ml=getmaillist(tripData, emplist, 1)
      var body="Trip Id: "+tripData.trip_id+" marked as Hold Ops"
      if(hoarr && hoarr.length>0){
        body="Hold Ops Reason: "+hoarr[hoarr.length-1].ho_reason
      }
      const finalarray={
        to:["amit.singh@jetovacations.com", ...ml],
        cc:["operations@jetovacations.com"],
        sub:"Trip Id: "+tripData.trip_id+" marked as Hold Ops",
        body:body
      }
      const data=sendmailtoteam(finalarray)
      const taskData={
    task_description: body,
    task_response: "",
    trip_id:tripData.trip_id,
    task_priority: "P1",
    task_category:"Hold Ops",
    assigned_to:getempTL(tripData.trip_owner, emplist),
    assigned_by:cuser,
    task_status:"Open",
    task_destination:tripData.primary_destination,
    ticket_category:"L1",
    createdAt:new Date()
  
      }
      const addtaskResponse= await addTask(taskData);
             
              if(addtaskResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
                  alert("New task added with task id "+addtaskResponse.data.task_id);
                  // var from="care@jetovacations.com"
                  // var subject="New task assigned to you with task id "+addtaskResponse.data.task_id
                  // //var subject="New task assigned to you with task id "
                  // var body="Ticket assigned with deadline "+("task_category" in taskData?taskData.task_category:"")+" || "+("deadline_date" in taskData?taskData.deadline_date:"")+" at "+("deadline_time" in taskData?taskData.deadline_time:"")
                  // var to=getrecepient(taskData.assigned_to)
                  // console.log(from, to, subject, body)
                  // let receiptmail= await gmailSend(from, to, subject, body)
                  // alert(receiptmail.data)
                  // window.location = ("/taskdataentry/"+addtaskResponse.data.task_id);
              }
              else{
                  alert("Something went wrong. Contact support");
                  // window.location = ("/");
              
              }
     }

     var temp={
           comment:tripData.supplier_payment_note,
           comment_date:new Date(),
           status:"Ops"
       }
       
      // if("invoice_total" in tripData && tripData.invoice_total>0 && total() !== tripData.invoice_total){
      //   alert("Total value does not match with invoice value sent to client")
      // }
            var finaltripData = {
        ...tripData,
        cust_payments: cpdata,
        supplier_payments: spdata,
        taxes:gettaxes(),
        no_tax:notax,
        on_hold:onhold,
        no_tcs:fdom,
        hightcs:hightcs,
        five_tcs:fivetcs,
        all_clear:allclear,
        tcs_mail:tcsmail,
        freeze_profit:fp,
        upsell_pitch:upsellpitch,
        hold_ops:holdops,
        hold_ops_array:hoarr,
        hold_ops_date:holdopsdate,
        only_flight:onlyflight,
        upsell:upsellData,
        changelog:changelog,
        tl_comment:[...tripData.tl_comment,temp]
      };
   

       const newprofit=getprofit(finaltripData)
       var pdarr=[...tripData.profit_decline_reason]
        //console.log(newprofit)
      
      if(supplierexisted && (oldprofit-newprofit)>5000){
        var comment=prompt("Enter profit decline reason: (minimum 20 characters). Old Profit: "+oldprofit)
        if(comment.length<20){
          alert("Need detailed reason for profit decline")
          return
        }else{
        pdarr=[...pdarr, comment]
        finaltripData={...finaltripData, profit_decline_reason:pdarr}
        var sendlist=["operations@jetovacations.com", "amit.singh@jetovacations.com", "debayan.ghosh@jetovacations.com", "abhishek.sharma@jetovacations.com", "rohit.saini@jetovacations.com", "product@jetovacations.com"]
        var tlname=employeelist.filter(e=>e.short_name==finaltripData.team_leader)
        if(tlname.length>0){
          sendlist=[...sendlist, tlname[0].email]
        }
        const finalarray={
          to:sendlist,
          sub:"Profit declined by: "+(oldprofit-newprofit)+" for "+tripData.trip_id+"("+tripData.trip_owner+")"+"-- converted on: ("+getconvdate(tripData)+")",
          body:comment
        }
        const data=sendmailtoteam(finalarray)
      }
      }

      if(findata.total - total()>3000){
         const finalarray={
          to:["operations@jetovacations.com", "amit.singh@jetovacations.com", "debayan.ghosh@jetovacations.com", "abhishek.sharma@jetovacations.com", "rohit.saini@jetovacations.com"],
          sub:"Revenue declined by: "+(findata.total-total())+" for "+tripData.trip_id+"("+tripData.trip_owner+")"+"--("+getconvdate(tripData)+")",
          body:"Significant revenue drop in trip. Please check. Old Revenue:"+findata.total + "New Revenue: "+total()
        }
        const data=sendmailtoteam(finalarray)
      }

    
      // const addhotelResponse= await addHotel(finalhotelData);
      // // dispatch(createCustomer(finalcustData));
      //console.log(finaltripData);
      
      const updatetripResponse = await updateTripdata(
        tripData._id,
        finaltripData
      );
     
      if (
        updatetripResponse.status == 200 ||
        201 ||
        202 ||
        203 ||
        204 ||
        205 ||
        206 ||
        207
      ) {
        alert(
          "Payment data updated for trip with trip id " +
            updatetripResponse.data.trip_id
        );
        window.location =
          "/tripdataentry/" +
          updatetripResponse.data.trip_id +
          "/paymentupdate";
      } else {
        alert("Something went wrong. Contact support");
        window.location = "/";
      }
    }
    }
  }catch(err){
    console.log(err)
  }
  };
  //console.log(tripData)

  const total = () => {
    let sum = 0;
    if (cpdata.length == 0) {
      return sum;
    } else {
      for(let i=0;i<cpdata.length;i++){
        if(cpdata[i].amount){
          if(cpdata[i].status=="Waive Off"){

          }else{
            if((cpdata[i].status == "Refund" || cpdata[i].status=="Credit Note" || cpdata[i].status == "Refund Due" || cpdata[i].status == "Internal Refund")){
              sum=sum-parseInt(cpdata[i].amount)
            }else{
               sum=sum+parseInt(cpdata[i].amount)
            }
          }
        }
        //console.log(sum)
      }
      // cpdata.map((item) =>
      //   item.amount
      //     ? (item.status=="Waive Off"?sum:(!(item.status == "Refund" || item.status=="Credit Note")
      //     ? (sum = sum + parseInt(item.amount))
      //     : (sum = sum - parseInt(item.amount))))
      //     : sum
      // );
      return sum;
      }
  };

  const sptotal = () => {
    let sum = 0;
    if (spdata.length == 0) {
      return sum;
    } else {
      spdata.map((item) =>
        item.amount
          ? item.status == "Forfeit"?sum:((item.status == "Refund" || item.status == "Refund Due" || item.status == "Refund claim by internal team") 
            ? (sum = sum - parseInt(item.amount))
            : (sum = sum + parseInt(item.amount)))
          : sum
      );
      return sum;
    }
  };

  const pending = () => {
    let sum = 0;
    if (cpdata.length == 0) {
      return sum;
    } else {
      cpdata.map((item) =>
        item.amount && item.status == "Pending"
          ? (sum = sum + parseInt(item.amount))
          : sum
      );
      return sum;
    }
  };

  const sppending = () => {
    let sum = 0;
    if (spdata.length == 0) {
      return sum;
    } else {
      spdata.map((item) =>
        item.amount && item.status == "Pending"
          ? (sum = sum + parseInt(item.amount))
          : sum
      );
      return sum;
    }
  };

  const gettcs=()=>{
    var t=identifydest(tripData.primary_destination)
     if(tripData.primary_destination=="Maldives" && new Date(getconvdate(tripData)).getTime()>new Date("2025-10-01").getTime()){
                 t=0
               }
     //console.log(tripData.primary_destination)
    var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_cp?tripData.extra_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)
    var convdate=""
    if(t && !notax && !onlyflight && !fdom && !onhold){
      if(tripData.trip_status=="Converted"){
        convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
    }else if(tripData.trip_status=="Closed"){
      convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
    }

     if(new Date(tripData.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
        if(fivetcs){
            return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.05):0
           }else{
            return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.02):0
           }
        
      }else if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
      return 0
    }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){
      //console.log(tripData.cruise_sp)
      if(hightcs){
        return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.20):0
      }else{
        return tripData.land_sp || tripData.cruise_sp?Math.round((parseInt(tripData.land_sp)+parseInt(tripData.cruise_sp))*0.05):0
      }
     
    }else{
      if(hightcs){
        return tripData.land_sp?Math.round((tripData.land_sp)*0.20):0
      }else{
        return tripData.land_sp?Math.round((tripData.land_sp)*0.05):0
      }
     
    }

    }else{
        //console.log("DEF")
        //setprice({...price,tcs:0})
        return 0
    }
  }
  
  const gettcs2=()=>{
    var t=identifydest(tripData.primary_destination)
     if(tripData.primary_destination=="Maldives" && new Date(getconvdate(tripData)).getTime()>new Date("2025-10-01").getTime()){
                 t=0
               }
      //console.log(t)
    //var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)-gettcs()
    var convdate=""
    var landpart=(total()-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
    //console.log(landpart)
    if(t && !notax && !onlyflight && !fdom && !onhold){
      if(tripData.trip_status=="Converted"){
          convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-1].date:""
      }else if(tripData.trip_status=="Closed"){
        convdate="status_history" in tripData && tripData.status_history.length>0?tripData.status_history[tripData.status_history.length-2].date:""
      }

       if(new Date(tripData.trip_start_date).getTime()>=new Date("2026-03-25").getTime()){
           landpart=(total(tripData.cust_payments)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.02
           if(fivetcs){
            return landpart?Math.round((parseInt(landpart))*0.05):0
           }else{
            return landpart?Math.round((parseInt(landpart))*0.02):0
           }
        }else if(new Date(convdate).getTime()<new Date("2023-04-01").getTime()){
        return 0
      }else if(new Date(convdate).getTime()>new Date("2023-08-15").getTime()){
        //console.log(tripData.cruise_sp)
        if(hightcs){
          landpart=(total()-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.2
          return landpart && landpart>0?Math.round((parseInt(landpart))*0.20):0
        }else{
          landpart=(total()-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))/1.05
          return landpart && landpart>0?Math.round((parseInt(landpart))*0.05):0
        }
      
      }else{
        if(hightcs){
          return landpart?Math.round((landpart)*0.20):0
        }else{
          return landpart?Math.round((landpart)*0.05):0
        }
      
      }

      
        
    }else{
        //console.log("DEF")
        //setprice({...price,tcs:0})
        return 0
    }
  }

  const getlandpart=()=>{
    var landpart=Math.round((total()-(tripData.high_tax_amount?tripData.high_tax_amount:0)-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_cp?tripData.extra_cp:0)-(tripData.flight_cp?tripData.flight_cp:0)-gettcs2())/1.05)
    return landpart
  }

  const gettaxes=()=>{
    //console.log("Running")
    var taxes=0
    if(notax){
      taxes=0
    }else if(onlyflight){
      var nontaxprofit2=(((tripData.flight_sp?tripData.flight_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))+((tripData.visa_sp?tripData.visa_sp:0)-(tripData.visa_cp?tripData.visa_cp:0))+((tripData.anc_sp?tripData.anc_sp:0)-(tripData.anc_cp?tripData.anc_cp:0))+((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))+((tripData.cruise_sp?tripData.cruise_sp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)))
     
      taxes=parseInt((nontaxprofit2-nontaxprofit2/1.18).toFixed(0))+parseInt((tripData.high_tax_amount?tripData.high_tax_amount/1.18*0.18:0).toFixed(0))
       console.log(nontaxprofit2, taxes)
    }else{
    
    var landpart=total()-(tripData.visa_cp?tripData.visa_cp:0)-(tripData.cruise_cp?tripData.cruise_cp:0)-(tripData.anc_cp?tripData.anc_cp:0)-(tripData.extra_sp?tripData.extra_sp:0)-(tripData.flight_cp?tripData.flight_cp:0)-(tripData.high_tax_amount?tripData.high_tax_amount:0)-gettcs2()
    if(tripData.land_sp>0){
      taxes=parseInt(((landpart-landpart/1.05)+(((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))-(((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))/1.18))).toFixed(0))+parseInt((tripData.high_tax_amount?tripData.high_tax_amount/1.18*0.18:0).toFixed(0))
    }else{
      var nontaxprofit=(((tripData.flight_sp?tripData.flight_sp:0)-(tripData.flight_cp?tripData.flight_cp:0))+((tripData.visa_sp?tripData.visa_sp:0)-(tripData.visa_cp?tripData.visa_cp:0))+((tripData.anc_sp?tripData.anc_sp:0)-(tripData.anc_cp?tripData.anc_cp:0))+((tripData.extra_sp?tripData.extra_sp:0)-(tripData.extra_cp?tripData.extra_cp:0))+((tripData.cruise_sp?tripData.cruise_sp:0)-(tripData.cruise_cp?tripData.cruise_cp:0))+(tripData.high_tax_amount?tripData.high_tax_amount:0))
      taxes=(nontaxprofit-nontaxprofit/1.18).toFixed(0)
    }
  }
  // if(tripData.high_tax_amount){
  //   taxes=parseInt(taxes)+(parseInt(tripData.high_tax_amount)*0.18).toFixed(0)
  // }
    return parseInt(taxes)
  }

  const getsuppliertype=(name)=>{
    const type=sData.filter(sup => sup.supplier_name==name)
    //console.log(type)
     return type.length>0?type[0].supplier_type:""
  }

  const getlandcp=()=>{
    var total=0
    for(let i=0; i<spdata.length; i++){
      if(spdata[i].supplier_type=="DMC" || spdata[i].supplier_type=="Hotel" || spdata[i].supplier_type=="Hotel Portal" || spdata[i].supplier_type=="Cab driver" || spdata[i].supplier_type=="Cab agency" || spdata[i].supplier_type=="Restaurant"){
        total=total+spdata[i].amount
        //console.log(total)
      }
    }
    return total
  }

  const whatsapp = async(e, amount, date, id) => {
    if (tripData.primary_mobile_number) {
      var text=""
      var button=""
      if (e.target.innerHTML == "Reminder 1"){
        text="Dear "+tripData.cust_name+",%0a%0aYour next installment of Rs."+amount+" is due on "+String(date).substring(0,10)+". Kindly make the payment"
        button="1"
      }else if(e.target.innerHTML == "Reminder 2"){
        text="Dear "+tripData.cust_name+",%0a%0aWe are yet to receive the installment of Rs."+amount+" due on "+String(date).substring(0,10)+". Kindly make the payment without delay" 
        button="2"
      }else if(e.target.innerHTML == "Reminder 3"){
        text="Dear "+tripData.cust_name+",%0a%0aWe still have not received your installment of Rs."+amount+" which was due on "+String(date).substring(0,10)+". Please understand timely payment is essential to provide a smooth delivery of services. Please make this payment without any further delay."
        button="3"
      }
      var temp={
        reminder_date:new Date(),
        reminder_button:button,
        collection_date:new Date(date),
      }
      //console.log(temp)
     
      var newcp=cpdata.map((item) => (item.id == id ? {...item,reminder:[...item.reminder,temp]} : item))
      var finaltripData={...tripData, cust_payments:newcp}
      // setcpdata(cpdata.map((item) => (item.id == id ? {...item,reminder:[...item.reminder,temp]} : item)));
      const updatetripResponse = await updateTripdata(
        tripData._id,
        finaltripData
      );
      // dispatch(createCustomer(finalcustData));
      //console.log(addcustResponse.data.cust_id);
      if (
        updatetripResponse.status == 200 ||
        201 ||
        202 ||
        203 ||
        204 ||
        205 ||
        206 ||
        207
      ) {
        alert(
          "Payment data updated for trip with trip id " +
            updatetripResponse.data.trip_id
        );
        window.location =
          "/tripdataentry/" +
          updatetripResponse.data.trip_id +
          "/paymentupdate";
      } else {
        alert("Something went wrong. Contact support");
        window.location = "/";
      }
    var win = window.open(
      `https://wa.me/91${tripData.primary_mobile_number}?text=${text}`,
      "_blank"
    );
  } else {
    alert(
      "Chat mobile number not present. Please enter number and try again"
    );
  }
};
//console.log(cpdata)
  init("user_DawJtilWyUWk4z5iay4qV");
  function sendmail() {
    //handlefunnelSearch();
    //console.log("working")
    
      // var templateParams = {
      //   email: emaillist[i],
      //   today_date: now.toString(),
      //   today_time: now
      //     .toLocaleString("en-IN")
      //     .toString()
      //     .split(",")
      //     .slice(1, 2),
      //   to_name: analytics4[i].employee,
      //   la: analytics4[i].daily_lead,
      //   cc: analytics4[i].daily_cust,
      //   tc: analytics4[i].daily_trips,
      //   canct: analytics4[i].daily_canc_trips,
      //   convt: analytics4[i].daily_conv_trips,
      //   hott: analytics4[i].daily_hot_trips,
      //   qc: analytics4[i].daily_quotes,
      //   qe: analytics4[i].daily_edit_quotes,
      //   fup: analytics4[i].daily_fup,
        //   };
      // };

      // emailjs.send("gmail", "template_su5aekc", templateParams).then(
      //   function (response) {
      //     alert("SUCCESS!", response.status, response.text);
      //   },
      //   function (error) {
      //     alert("FAILED...", error);
      //   }
      // );
    
  }
//console.log(notax)
const openmodal=()=>{
  setmodal(true);
}

const handleClose = () =>{
  setmodal(false);
}

const handleClose2 = () =>{
  setschedule(false);
  //handleSubmit()
}

const removeValue = (arr, value) => arr.filter(item => item !== value);

const sendreceiptmail=async() => {
  const data=await fetchCustomerbyId(tripData.cust_id)
  const data2=await fetchEmployeebyName(tripData.trip_owner)
  //console.log(data2.data)
  const data3=await fetchEmployeebyName(data2.data.reporting_manager)
  //alert(data.data.primary_email_id, data2.data.email,data3.data.email)
  //const div=document.getElementById("payment")
  let from="care@jetovacations.com"
  var to=[data.data.primary_email_id, data2.data.email,data3.data.email, "accountsteam@jetovacations.com"]//data.data.primary_email_id,//data2.data.email
  let subject="Payment received by Jeto Vacations"
  let varbody=[`
    <p>Hello ${tripData.cust_name}</p>
    <p>Greetings from Jeto Vacations!</p>
    <p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
    <p>Total package amount: Rs.<b>${total()}</b></p>
    <table border="1">
<tr>
<th align="center"><b>Date</b></th>
<th align="center"><b>Amount</b></th>
<th align="center"><b>Status</b></th>
</tr>
<tr>
<td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
<td align="center">${cpdata[0]?.amount}</td>
<td align="center">${cpdata[0]?.status}</td>
</tr>
</table>
  `,
  `
  <p>Hello ${tripData.cust_name}</p>
  <p>Greetings from Jeto Vacations!</p>
  <p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
  <p>Total package amount: Rs.<b>${total()}</b></p>
  <table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[7]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[7]?.amount}</td>
  <td align="center">${cpdata[7]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[7]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[7]?.amount}</td>
  <td align="center">${cpdata[7]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[8]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[8]?.amount}</td>
  <td align="center">${cpdata[8]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello ${tripData.cust_name}</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[7]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[7]?.amount}</td>
  <td align="center">${cpdata[7]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[8]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[8]?.amount}</td>
  <td align="center">${cpdata[8]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[9]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[9]?.amount}</td>
  <td align="center">${cpdata[9]?.status}</td>
  </tr>
  </table>
`
]
  to = removeValue(to, "xyz@gmail.com");
  var cpdata2=cpdata.filter(cp=>cp.status=="Received")
  let body=varbody[cpdata.length-1];
  // if(cpdata2.length>0){
  //   var body2="Hi "+tripData.cust_name+"%0a%0a"+"Greetings from Jeto Vacations!"+"%0a%0a"+"We have received payment of Rs."+cpdata2[cpdata2.length-1].amount+" on "+cpdata2[cpdata2.length-1].date.split("T").slice(0,1)+" for trip id: "+tripData.trip_id+"%0a%0a"+"For any further enquires, please drop a message on the whatsaapp group created for your trip"
  //   //console.log(cpdata)
  //   //console.log(tripData.primary_mobile_number)
  
  //   var win = window.open(
  //     `https://wa.me/91${tripData.primary_mobile_number}?text=${body2}`,
  //     "_blank"
  //   );
  // }
  
  var x=window.confirm("Email id is: "+data.data.primary_email_id+" || Proceed?")
  if(x){
  let receiptmail= await gmailSend(from, to, subject, body)
  alert(receiptmail.data)
  }
}

const changeHandler = (event) => {
  setSelectedFile(event.target.files[0]);
  setIsSelected(true)
};

const changeHandler2 = (event) => {
  setSelectedFile2(event.target.files[0]);
  setIsSelected(true)
};

const sendreceiptmail2=async() => {
  const formData = new FormData();

	formData.append('File', selectedFile);
  const formData2 = new FormData();

	formData2.append('File2', selectedFile2);
  console.log(formData)
  const data=await fetchCustomerbyId(tripData.cust_id)
  const data2=await fetchEmployeebyName(tripData.trip_owner)
  //console.log(data2.data)
  const data3=await fetchEmployeebyName(data2.data.reporting_manager)
  //alert(data.data.primary_email_id, data2.data.email,data3.data.email)
  //const div=document.getElementById("payment")
  let from="care@jetovacations.com"
  var to=["nayabed750@gmail.com","debayan.ghosh@jetovacations.com"]//data.data.primary_email_id,//data2.data.email
  let subject="Payment received by Jeto Vacations"
  let varbody=[`
    <p>Hello</p>
    <p>Greetings from Jeto Vacations!</p>
    <p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
    <p>Total package amount: Rs.<b>${total()}</b></p>
    <table border="1">
<tr>
<th align="center"><b>Date</b></th>
<th align="center"><b>Amount</b></th>
<th align="center"><b>Status</b></th>
</tr>
<tr>
<td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
<td align="center">${cpdata[0]?.amount}</td>
<td align="center">${cpdata[0]?.status}</td>
</tr>
</table>
  `,
  `
  <p>Hello</p>
  <p>Greetings from Jeto Vacations!</p>
  <p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
  <p>Total package amount: Rs.<b>${total()}</b></p>
  <table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[7]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[7]?.amount}</td>
  <td align="center">${cpdata[7]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[7]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[7]?.amount}</td>
  <td align="center">${cpdata[7]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[8]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[8]?.amount}</td>
  <td align="center">${cpdata[8]?.status}</td>
  </tr>
  </table>
`,
`
<p>Hello</p>
<p>Greetings from Jeto Vacations!</p>
<p>Thank you for giving us the opportunity to serve you. Please see the payment details below:</p>
<p>Total package amount: Rs.<b>${total()}</b></p>
<table border="1">
  <tr>
  <th align="center"><b>Date</b></th>
  <th align="center"><b>Amount</b></th>
  <th align="center"><b>Status</b></th>
  </tr>
  <tr>
  <td align="center">${cpdata[0]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[0]?.amount}</td>
  <td align="center">${cpdata[0]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[1]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[1]?.amount}</td>
  <td align="center">${cpdata[1]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[2]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[2]?.amount}</td>
  <td align="center">${cpdata[2]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[3]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[3]?.amount}</td>
  <td align="center">${cpdata[3]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[4]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[4]?.amount}</td>
  <td align="center">${cpdata[4]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[5]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[5]?.amount}</td>
  <td align="center">${cpdata[5]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[6]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[6]?.amount}</td>
  <td align="center">${cpdata[6]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[7]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[7]?.amount}</td>
  <td align="center">${cpdata[7]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[8]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[8]?.amount}</td>
  <td align="center">${cpdata[8]?.status}</td>
  </tr>
  <tr>
  <td align="center">${cpdata[9]?.date.split("T").slice(0,1)}</td>
  <td align="center">${cpdata[9]?.amount}</td>
  <td align="center">${cpdata[9]?.status}</td>
  </tr>
  </table>
`
]
  to = removeValue(to, "xyz@gmail.com");
  let body=varbody[cpdata.length-1];
  let receiptmail=gmailSend(from, to, subject, body, formData, formData2)
  //setmodal(false)
  
}

const openschedule=()=>{
  if(role=="Sales"){
  var e=prompt("Enter email id of customer")
  var e2=e.trim()
  settripData({...tripData, primary_email_id:e2})
  
  }
  setschedule(true)
  //setscheduledata(varbody)
}

const getpaymentrule=(name)=>{
  const type=sData.filter(sup => sup.supplier_name==name)
  var dop=""
   const rule= type.length>0?type[0].supplier_payment_rule:""
   if(rule){
    dop=paymentdate(rule, tripData.trip_start_date)
   }
   return rule+"  --- "+dop
}

const freezeprofit=(e)=>{
  var profit=total()-gettaxes()-sptotal()-gettcs2()
  setfp(!fp)
  if(e.target.checked==true){
    settripData({...tripData, sales_profit:profit})
    let x=window.prompt("Sales profit finalized at "+profit+". Save trip?")
    if(x){
      handleSubmit(null)
    }
  }
}

const checknumberbooking=async(name)=>{
  try{
    var temp=name.replaceAll("%20"," ")
                    
    const data=await getsupplierbookingrecord(DateCalc(-30), DateCalc(1), temp)
    console.log(data.data)
    var temp3=data.data.filter(t=>new Date(t.trip_start_date).getTime()>new Date().getTime())
    var temp2=removeDuplicates(temp3,"trip_id")
    alert("Approx. number of confirmed bookings with this supplier in the last 30 days: "+temp2.length)
  }catch(err){
    console.log(err)
  }
}

const handleclose3=()=>{
  setopen2(false)
}

const handleclosecl=()=>{
  setshowcl(false)
}

const upselltotal = (upsellData) => {
    let sum = 0;
    if (upsellData.length == 0) {
      return sum;
    } else {
      upsellData.map((item) =>
          item.inventory=="Hotel Upsell Ops"?sum:
          (sum = sum + parseInt(item.sp))
      );
      return sum;
    }
  };

  const upsellcosttotal = (upsellData) => {
    let sum = 0;
    if (upsellData.length == 0) {
      return sum;
    } else {
      upsellData.map((item) =>
       
          (sum = sum + parseInt(item.cp))
      );
      return sum;
    }
  };

  const upsellprofittotal = () => {
    let sum = 0;
    if (upsellData.length == 0) {
      return sum;
    } else {
      upsellData.map((item) =>
            item.inventory=="Hotel Upsell Ops"?sum:
           (item.inventory=="SIM" || item.inventory=="Insurance" || item.inventory=="Arrival Card"?
            (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.18)):
           (sum = sum + ((parseInt(item.sp)-parseInt(item.cp))/1.05)))
      );
      return Math.round(sum);
    }
  };

  const getdisabled=(type, item)=>{
    var x=false
    if(role=="Accounts"){
     
    }else{
    if(type=="Date" || type=="Amount"){
      if(item.status=="Received" || item.status=="Refund" || item.status=="Internal Refund" || item.status=="Waive Off" || item.status=="Credit Note" || item.status=="Paid to Supplier Directly"){
        x=1
      }
    }else{
      x=1
    }
  }
  //console.log(x)
  return x
  }

  const holdopschange=(e)=>{
    setholdops(!holdops)
    var r=""
    if(!e.target.checked){
      r="Hold ops removed"
    }else{
      r=window.prompt("Enter reason for hold ops:")
    }
    var temp={
        ho_date:new Date(),
        ho_reason:r,
        ho_by:cuser,
        ho_status:e.target.checked,
    }
    sethoarr([...hoarr, temp])
  }

  //console.log(spdata)
  return (
    <div>
    <Modal open={modal} onClose={handleClose}>
    <form>
          <div className={classes.modalText}>
          <label for="invoice">Upload Invoice</label>
            <input name="invoice" type="file" onChange={changeHandler}/>
            <p></p>
            <label for="quote">Upload Quote</label>
            <input name="quote" type="file" onChange={changeHandler2}/>
            <div>
				<button onClick={sendreceiptmail2}>Send</button>
        
			</div>
          
          {isSelected ? (
				<div>
                    <h2>File Details</h2>
					<p>Filename: {selectedFile.name}</p>
					<p>Filetype: {selectedFile.type}</p>
					<p>Size in bytes: {selectedFile.size}</p>
					<p>
						lastModifiedDate:{' '}
						{selectedFile.lastModifiedDate.toLocaleDateString()}
					</p>
				</div>
			) : (
				<p>Select a file to show details</p>
			)}
      </div>
          </form>

        </Modal>
        <Dialog open={schedule} onClose={handleClose2} fullWidth
        maxWidth="sm">
     <div align="center">
   <br></br>
   <br></br>
   <br></br>
    <table border="1" >
<tr>
<th align="center"><b>Date</b></th>
<th align="center"><b>Amount</b></th>
<th align="center"><b>Status</b></th>
</tr>
{cpdata.map(cp=>
<tr>
<td align="center">{cp && "date" in cp && cp.date?cp.date.split("T").slice(0,1):""}</td>
<td align="center">{cp && "amount" in cp?cp.amount:""}</td>
<td align="center">{cp && "status" in cp?cp.status:""}</td>
</tr>
)}
</table>
   <br></br>
   <br></br>
   <br></br>
  </div>

  ------------------------------------------------------------------------------------------
  {custData.primary_email_id}

  <p> Order received for upcoming trip to {tripData.primary_destination} for {custData.cust_name} || Trip Id: {tripData.trip_id}</p>
  <br></br>
  <br></br>
  <p> Hi {custData.cust_name},</p>
  <p> Greetings from Jeto Vacations!</p>
  <p> Thank you for the opportunity to serve you.</p>
  <p>As per your request, we will now proceed with the bookings for your upcoming trip to {tripData.primary_destination}</p>
  <p>Please find the payment schedule for your trip:</p>
  <div align="center">
    <table border="1" >
<tr>
<th align="center"><b>Date</b></th>
<th align="center"><b>Amount</b></th>
<th align="center"><b>Status</b></th>
</tr>
{cpdata.map(cp=>
<tr>
<td align="center">{cp && "date" in cp?cp.date.split("T").slice(0,1):""}</td>
<td align="center">{cp && "amount" in cp?cp.amount:""}</td>
<td align="center">{cp && "status" in cp?cp.status:""}</td>
</tr>
)}
</table>
  </div>
  <br></br>
  <p>If you have paid any amount but it still shows pending, please wait 48 hours for it get marked in system. No need to worry about these. Your payment is secure</p>
  <br></br>
  <p><b>We will try our best to adhere to these dates. But if there is any requirement for hotel blocking, we may request you to pay in advance. We kindly request you to co-operate in such cases.</b></p>
  <br></br>
  <p>Also, your final quote, tentative itinerary and invoice (with terms and conditions) are attached below.</p>
  <p>Terms and conditions applicable for your bookings is mentioned at https://www.jetovacations.com/tnc. The same is also included in your quote.</p>
  <p>If you have any concerns with any of the above mentioned documents or schedule, please reply to us within the next 48 hours after which we will consider that you are okay with all the arrangements mentioned above.</p>
  <br></br>
  <p>Please provide your GST registration details if applicable. If we do not receive your GST information, we will file your invoice under B2C (Business to Consumer) category as per compliance requirements, and no further amendments will be possible.</p>
  <br></br>
  {/* {identifydest(tripData.primary_destination)?(
    <div>
    <p><b>As per the new RBI guidelines, from 1st Oct 2023, TCS for overseas tour package will be levied at 20% if remittance for the current financial year against your PAN card crosses Rs. 10 lacs. If remittance has not crossed Rs. 10 lacs, TCS will be levied at 5% only. Please reply to this email confirming if remittance against your PAN card (mention PAN number)  is within the initial limit of Rs. 10 lacs. This is of utmost importance because without your explicit confirmation, we will be forced to charge 20% TCS (instead of 5%) to comply with existing laws. The additional 15% will be added to your final installment automatically.</b></p>
  <br></br>
  <p>To confirm your TCS amount, kindly do the following:</p>
  <p><b>Step 1: Click the link: <a href="https://www.jetovacations.com/newlogin" target="_blank" rel="noreferrer">Jeto Website Link</a></b></p>
  <p><b>Step 2: Enter user id ({tripData.trip_id})and password ({tripData.trip_password})</b></p>
  <p><b>Step 3: Select your appropriate TCS level and click on "Save"</b></p>
  <p>If you need any help, do contact me immediately</p>
  </div>
  ):( */}
    <div>
    <p>To confirm your trip related information and all documents:</p>
  <p><b>Step 1: Click the link: <a href="https://www.jetovacations.com/newlogin" target="_blank" rel="noreferrer">Jeto Website Link</a></b></p>
  <p><b>Step 2: Enter user id ({tripData.trip_id})and password ({tripData.trip_password})</b></p> 
  <p>If you need any help, do contact me immediately</p>
    </div>
  {/* )} */}
  
  <p>In case, I am unavailable or unable to receive your call, you can always reach out to our operations team (Ph- 8448419748 / 9667604658 / 7303926748) </p>
  <p>Thanks & Regards</p>
  <p>{tripData.trip_owner}</p>

  ------------------------------------------------------------------------------------------------------
  <p> Hi {custData.cust_name},</p>
  <p>Please find the payment options:</p>
  <p>1. UPI: jetovacations@kotak</p>
  <p>2. Bank transfer:</p>
  <p>Beneficiary name: Jeto Vacations Private Limited</p>
  <p>Bank: Kotak Mahindra Bank</p>
  <p>Account number: 8912958952</p>
  <p>IFSC Code: KKBK0004629</p>
  <p>Type: Current Account</p>
  <p>3. Card payment:</p>
  <p>Link: https://pages.razorpay.com/pl_DmzPh0B2avRZLq/view</p>
  <p>Charges: 2.36% to 3.54% for credit cards and UPI with Rupay Credit Cards, 1.18% for debit cards, 3.54% for American Express, EMI or Pay Later options</p>
  <p>Please find the payment schedule for your trip:</p>
  <div align="center">
    <table border="1" >
<tr>
<th align="center"><b>Date</b></th>
<th align="center"><b>Amount</b></th>
<th align="center"><b>Status</b></th>
</tr>
{cpdata.map(cp=>
<tr>
<td align="center">{cp && "date" in cp?cp.date.split("T").slice(0,1):""}</td>
<td align="center">{cp && "amount" in cp?cp.amount:""}</td>
<td align="center">{cp && "status" in cp?cp.status:""}</td>
</tr>
)}
</table>
  </div>
  <p>If you have any concerns with any of the above mentioned schedule, please reply to us within the next 48 hours after which we will consider that you are okay with all the arrangements mentioned above.</p>
  <p>By making payment, you agree to abide by all terms and conditions mentioned at https://www.jetovacations.com/tnc</p>
        </Dialog>
        <Dialog open={open2} onClose={handleclose3} fullWidth maxWidth="l">
        <div align="center">
             <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Upsell (Total:{upselltotal(upsellData)} || Profit:{upsellprofittotal()}) 
        </Typography>
              <Typography variant="h6" align="center" className={classes.headertext}>
          {" "}
          Upsell Pitch
        </Typography>
        <FormGroup row className={classes.formgroup}>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "tour" in upsellpitch?upsellpitch.tour:false} checked={upsellpitch && "tour" in upsellpitch?upsellpitch.tour:false} label="Tour" onChange={(e)=> setupsellpitch({...upsellpitch,tour:e.target.checked})}/>
           <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "hotel" in upsellpitch?upsellpitch.hotel:false} checked={upsellpitch && "hotel" in upsellpitch?upsellpitch.hotel:false} label="Hotel" onChange={(e)=> setupsellpitch({...upsellpitch,hotel:e.target.checked})}/>
            <FormControlLabel control={<Checkbox color="primary"/>} value={upsellpitch && "insurance" in upsellpitch?upsellpitch.insurance:false} checked={upsellpitch && "insurance" in upsellpitch?upsellpitch.insurance:false} label="Insurance" onChange={(e)=> setupsellpitch({...upsellpitch,insurance:e.target.checked})}/>
             <FormControlLabel control={<Checkbox color="primary"/>} value={upsellpitch && "sim" in upsellpitch?upsellpitch.sim:false} checked={upsellpitch && "sim" in upsellpitch?upsellpitch.sim:false} label="Sim" onChange={(e)=> setupsellpitch({...upsellpitch,sim:e.target.checked})}/>
              <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "ac" in upsellpitch?upsellpitch.ac:false} checked={upsellpitch && "ac" in upsellpitch?upsellpitch.ac:false} label="AC" onChange={(e)=> setupsellpitch({...upsellpitch,ac:e.target.checked})}/>
               <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "visa" in upsellpitch?upsellpitch.visa:false} checked={upsellpitch && "visa" in upsellpitch?upsellpitch.visa:false} label="Visa" onChange={(e)=> setupsellpitch({...upsellpitch,visa:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "flight" in upsellpitch?upsellpitch.flight:false} checked={upsellpitch && "flight" in upsellpitch?upsellpitch.flight:false} label="Flight" onChange={(e)=> setupsellpitch({...upsellpitch,flight:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "forex" in upsellpitch?upsellpitch.forex:false} checked={upsellpitch && "forex" in upsellpitch?upsellpitch.forex:false} label="Forex" onChange={(e)=> setupsellpitch({...upsellpitch,forex:e.target.checked})}/>
                <FormControlLabel control={<Checkbox color="primary"/>}  value={upsellpitch && "others" in upsellpitch?upsellpitch.others:false} checked={upsellpitch && "others" in upsellpitch?upsellpitch.others:false} label="Others" onChange={(e)=> setupsellpitch({...upsellpitch,others:e.target.checked})}/>
        </FormGroup>
            {upsellData.length>0?(<div>
              {upsellData.map(u=>{return(
                 <FormGroup row className={classes.formgroup}>
                       <FormControl
                    style={{
                      minWidth: 360,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="inventory">Inventory</InputLabel>
                    <Select
                      displayEmpty
                      disabled={(role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Admin") && tripData.trip_status=="Converted"?0:1}
                      classname={classes.textField2}
                      labelId="inventory"
                      name={upsellData.indexOf(u)}
                      value={u.inventory}
                      onChange={(e) => setupsellData(upsellData.map(up=>upsellData.indexOf(u)==upsellData.indexOf(up)?{...up, inventory: e.target.value}:up))}
                    >
                    <MenuItem value={"Tour"}>Tour</MenuItem>
                    <MenuItem value={"Hotel"}>Hotel</MenuItem>
                    <MenuItem value={"Insurance"}>Insurance</MenuItem>
                    <MenuItem value={"Arrival Card"}>Arrival Card</MenuItem>
                    <MenuItem value={"SIM"}>SIM</MenuItem>
                    <MenuItem value={"Visa"}>Visa</MenuItem>
                    <MenuItem value={"Flight Fare"}>Flight Fare</MenuItem> 
                    <MenuItem value={"Flight Ancilliary"}>Flight Ancilliary</MenuItem> 
                    <MenuItem value={"Forex Cash"}>Forex Cash</MenuItem> 
                    <MenuItem value={"Forex Card"}>Forex Card</MenuItem> 
                    <MenuItem value={"Others"}>Others</MenuItem> 
                    <MenuItem value={"Hotel Upsell Ops"}>Hotel Upsell Ops</MenuItem> 
                    </Select>
                  </FormControl>
                   <TextField
                    variant="standard"
                    label="CP (number)"
                    disabled={(role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Admin") && tripData.trip_status=="Converted"?0:1}
                    id={upsellData.indexOf(u)}
                    value={u.cp}
                    className={classes.textField4}
                    onChange={(e) => setupsellData(upsellData.map(up=>upsellData.indexOf(u)==upsellData.indexOf(up)?{...up, cp: e.target.value}:up))}
                  />
                    <TextField
                    variant="standard"
                    label="SP (number)"
                    disabled={(role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Admin") && tripData.trip_status=="Converted"?0:1}
                    id={upsellData.indexOf(u)}
                    value={u.sp}
                    className={classes.textField4}
                    onChange={(e) => setupsellData(upsellData.map(up=>upsellData.indexOf(u)==upsellData.indexOf(up)?{...up, sp: e.target.value}:up))}
                  />
                  <TextField
                    variant="standard"
                    label="Note"
                    disabled={(role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Admin") && tripData.trip_status=="Converted"?0:1}
                    id={upsellData.indexOf(u)}
                    value={u.notes}
                    className={classes.textField}
                    onChange={(e) => setupsellData(upsellData.map(up=>upsellData.indexOf(u)==upsellData.indexOf(up)?{...up, notes: e.target.value}:up))}
                  />
                  <FormControl
                    style={{
                      minWidth: 360,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="ops">Ops</InputLabel>
                    <Select
                      displayEmpty
                      disabled={(role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Admin") && tripData.trip_status=="Converted"?0:1}
                      classname={classes.textField2}
                      labelId="ops"
                      name={upsellData.indexOf(u)}
                      value={u.inventory}
                      onChange={(e) => setupsellData(upsellData.map(up=>upsellData.indexOf(u)==upsellData.indexOf(up)?{...up, ops: e.target.value}:up))}
                    >
                    {empops.map((emp) => (
                                      <MenuItem value={emp}>{emp}</MenuItem>
                                    ))}
                    </Select>
                  </FormControl>
                 </FormGroup>
              )})}
              
            </div>):("No Upsell Data found")}
            <br></br>
            <br></br>
                  <Typography variant="h6" align="center" className={classes.headertext}>
          {" "}
          Complementary
        </Typography>
        <FormGroup row className={classes.formgroup}>
          
            <FormControlLabel control={<Checkbox color="secondary"/>} value={"complementary_insurance" in tripData?tripData.complementary_insurance:false} checked={"complementary_insurance" in tripData?tripData.complementary_insurance:false} label="Insurance" onChange={(e)=> settripData({...tripData,complementary_insurance:e.target.checked})}/>
              <FormControlLabel control={<Checkbox color="secondary"/>} value={"complementary_sim" in tripData?tripData.complementary_sim:false} checked={"complementary_sim" in tripData?tripData.complementary_sim:false} label="Sim" onChange={(e)=> settripData({...tripData,complementary_sim:e.target.checked})}/>
              <FormControlLabel control={<Checkbox color="secondary"/>} value={"complementary_ac" in tripData?tripData.complementary_ac:false} checked={"complementary_ac" in tripData?tripData.complementary_ac:false} label="Arrival Card" onChange={(e)=> settripData({...tripData,complementary_ac:e.target.checked})}/>
            
        </FormGroup>
        <br></br>
        <br></br>
            {tripData.trip_status=="Converted"?(
               <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>{setupsellData([...upsellData,{inventory:"", cp:0, sp:0}]);setallclear(false)}}
              
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>setupsellData([...upsellData].slice(0, upsellData.length - 1))}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
          ):("")}
        </div>
        </Dialog>
        <Dialog open={showcl} onClose={handleclosecl} fullWidth maxWidth="l">
          {/* {changelog && changelog.length>0 && changelog.map((c, i)=>
            <p key={i}>
              &nbsp;&nbsp;For tranche {typeof c.tranche === "object" ? JSON.stringify(c.tranche) : c.tranche}, {c.entity} changed from {String(c.old_value)} to {String(c.new_value)} by {c.changed_by} on {c.changed_date ? new Date(c.changed_date).toLocaleString() : ""}
            </p>
          )} */}
          <Table>
          <TableHead>
            <TableCell>Tranche</TableCell>
            <TableCell>Entity</TableCell>
            <TableCell>Old Value</TableCell>
            <TableCell>New Value</TableCell>
            <TableCell>Changed BY</TableCell>
            <TableCell>Change Date</TableCell>
            <TableCell>Profit Change</TableCell>
          </TableHead>
           {changelog && changelog.length>0 && reversesortByKey(changelog, "changed_date").map((c, i)=>
          
          
            <TableRow>
              <TableCell>{typeof c.tranche === "object" ? JSON.stringify(c.tranche) : c.tranche}</TableCell>
              <TableCell>{c.entity}</TableCell>
              <TableCell>{String(c.old_value)}</TableCell>
              <TableCell>{String(c.new_value)}</TableCell>
              <TableCell>{c.changed_by}</TableCell>
              <TableCell>{c.changed_date ? new Date(c.changed_date).toLocaleString() : ""}</TableCell>
              <TableCell>{String(c.old_profit)+" -- "+String(c.new_profit)}</TableCell>
            </TableRow>
        
            )}
              </Table>
        </Dialog>
     
    {!loading && role && cuser ?(
      <Paper variant="outlined" className={classes.paper} elevation={10}>
      <div>
      <FormGroup row className={classes.formgroup}>
      <Button
          variant="outlined"
          color="inherit"
          className={classes.button2}
          href={"/tripdataentry/" + tripData.trip_id}
        >
          {" "}
          Back to Trip
        </Button>
        
        <Button
          variant="outlined"
          color="inherit"
          className={classes.button2}
          href={"/tripdataentry/" + tripData.trip_id + "/invoice"}
        >
          {" "}
          Create Invoice
        </Button>
        {role=="Operations" || role=="Operations-TL" || role=="Accounts" || role=="Admin" ||role=="Product"?(
         <Button
          variant="outlined"
          color="inherit"
          className={classes.button2}
          onClick={()=>setopen2(true)}
        >
          {" "}
          Upsell
        </Button>
        ):("")}
        <div>
          <Button variant="outlined"
          color="primary"
          className={classes.button2}
          onClick={openschedule}>View Messages</Button>
          </div>
           <div>
          <Button variant="outlined"
          color="primary"
          className={classes.button2}
          onClick={()=>setshowcl(true)}>Change Log</Button>
          </div>
          {role=="Admin" || role=="Accounts"?(
          <div>
          <Button variant="outlined"
          color="primary"
          className={classes.button2}
          onClick={sendreceiptmail}>Send Receipt Mail</Button>
          {/* <Button variant="outlined"
          color="primary"
          className={classes.button2}
          onClick={openmodal}>Send Mail with files</Button> */}
          </div>
        ):("")}
        <br></br>
        {"hold_ops_array" in tripData && tripData.hold_ops_array.length>0?(
          <div>Hold Ops due to: {tripData.hold_ops_array[tripData.hold_ops_array.length-1].ho_reason}</div>
        ):(
          ""
        )}
        <br></br>
          {cuser=="Pawan" || cuser=="Debayan" || role=="Accounts"?(
            <div>
        <FormControlLabel control={<Checkbox color="primary"/>}  value={allclear} checked={allclear} label="Accounts All Clear?" onChange={(e)=> setallclear(!allclear)}/>
        <FormControlLabel control={<Checkbox color="primary"/>}  value={tcsmail} checked={tcsmail} label="TCS mail?" onChange={(e)=> settcsmail(!tcsmail)}/>
        
        </div>
        ):("")}
        {cuser=="Pawan" || cuser=="Debayan" || role=="Accounts" || cuser=="Tarun"?(
          <FormControlLabel control={<Checkbox color="primary"/>}  value={onhold} checked={onhold} label="On Hold?" onChange={(e)=> setonhold(!onhold)}/>
        ):("")}
        {cuser=="Abhishek" || cuser=="Debayan" || cuser=="RohitS" || cuser=="Amit"?(
            <div>
       
     <FormControlLabel control={<Checkbox color="primary"/>}  value={fp} checked={fp} label="Freeze Profit?" onChange={(e)=> freezeprofit(e)}/>
      <TextField
                    variant="standard"
                   
                    
               
                    InputLabelProps={{ shrink: true }}
                    value={
                     tripData.sales_profit?tripData.sales_profit:0
                    }
                    className={classes.textFieldnew}
                    onChange={(e) => settripData({...tripData, sales_profit:e.target.value})}
                    
                  />
    
        </div>
        ):("")}
        {role=="Admin" || role=="Manager" || role=="TL" || role=="Operations" || role=="Operations-TL" || role=="Product" || role=="Accounts" || role=="Support"?(
          <div>
           <FormControlLabel control={<Checkbox color="primary"/>}  disabled value={"booking" in tripData && "invoice_name_matched" in tripData.booking && tripData.booking.invoice_name_matched?true:false} checked={"booking" in tripData && "invoice_name_matched" in tripData.booking && tripData.booking.invoice_name_matched?true:false} label="Invoice Name Confirmed?"/>
          {/* <FormControlLabel control={<Checkbox color="primary"/>}  disabled={(cuser=="Pawan" || cuser=="Debayan" || cuser=="Tarun") ?0:1} value={onhold} checked={onhold} label="On Hold?" onChange={(e)=> setonhold(!onhold)}/> */}
          <FormControlLabel control={<Checkbox color="primary"/>}  disabled={(cuser=="Debayan") ?0:1} value={notax} checked={notax} label="Special case?" onChange={(e)=> setnotax(!notax)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  disabled={( cuser=="Debayan") ?0:1} value={onlyflight} checked={onlyflight} label="Only Flight?" onChange={(e)=> setonlyflight(!onlyflight)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  disabled={(cuser=="Debayan") ?0:1} value={fdom} checked={fdom} label="Proxy Dom?" onChange={(e)=> setfdom(!fdom)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  disabled={(cuser=="Pawan" || cuser=="Debayan") ?0:1} value={hightcs} checked={hightcs} label="20% TCS?" onChange={(e)=> sethightcs(!hightcs)}/>
           <FormControlLabel control={<Checkbox color="primary"/>}  disabled={(cuser=="Pawan" || cuser=="Debayan") ?0:1} value={fivetcs} checked={fivetcs} label="5% TCS?" onChange={(e)=> setfivetcs(!fivetcs)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  disabled={role=="Operations" || role=="Admin" || role=="Operations-TL" || role=="Product"?0:1} value={holdops} checked={holdops} label="Hold Ops?" onChange={(e)=> holdopschange(e)}/>
          <FormControlLabel control={<Checkbox color="primary"/>}  value={"product_check" in tripData?tripData.product_check:false} checked={"product_check" in tripData?tripData.product_check:false} label="Checked by Product?" onChange={(e)=> settripData({...tripData, product_check:!tripData.product_check})}/>
          </div>
        ):(
          <div>
          <FormControlLabel control={<Checkbox color="primary"/>}  disabled value={onhold} checked={onhold} label="On Hold?" onChange={(e)=> setonhold(!onhold)}/>
          </div>
        )}
       
        </FormGroup>
        </div>
       
        <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Customer Payments (Total:{total()}) || (Pending:{pending()} || Profit:{total()-gettaxes()-sptotal()-gettcs2()}) {fp && "sales_profit" in tripData?("|| Increment: "+((total()-gettaxes()-sptotal()-gettcs2())-tripData.sales_profit)):""} || Invoice Value: {tripData.invoice_total}
        </Typography>
        {role=="Accounts" || role=="Admin"?(
          <Typography variant="h4" align="center" className={classes.headertext}>
          {" "}
          Available for supplier payment:{total()-pending()-(sptotal()-sppending())} 
        </Typography>
        ):("")}
        <FormGroup row className={classes.formgroup}>
          <TextField
            variant="standard"
            type="Number"
            label="Flight Price"
            InputLabelProps={{ shrink: true }}
            value={tripData.flight_sp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, flight_sp: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="Number"
            label="Visa Price"
            InputLabelProps={{ shrink: true }}
            value={tripData.visa_sp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, visa_sp: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="Number"
            label="Ancilliary Price"
            InputLabelProps={{ shrink: true }}
            value={tripData.anc_sp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, anc_sp: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="Number"
            label="AC/SIM/Insurance"
            InputLabelProps={{ shrink: true }}
            value={tripData.extra_sp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, extra_sp: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="Number"
            label="Cruise Price"
            InputLabelProps={{ shrink: true }}
            value={tripData.cruise_sp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, cruise_sp: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="Number"
            label="Land Price (incl. taxes)"
            InputLabelProps={{ shrink: true }}
            value={tripData.land_sp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, land_sp: e.target.value })
            }
          />
          <TextField
            variant="standard"
            type="Number"
            label="Taxes"
            InputLabelProps={{ shrink: true }}
            value={gettaxes()}
            className={classes.textField2}
            disabled
          />
          <TextField
            variant="standard"
            disabled
            label="TCS Charged"
            InputLabelProps={{ shrink: true }}
            value={gettcs()}
            className={classes.textField2}
            
          />
          {role=="Admin" || role=="Accounts"?(<div>
            <TextField
            variant="standard"
            disabled
            label="TCS to be paid"
            InputLabelProps={{ shrink: true }}
            value={gettcs2()}
            className={classes.textField2}
            
          />
           <TextField
            variant="standard"
            disabled
            label="TCS Diff"
            InputLabelProps={{ shrink: true }}
            value={gettcs2()-gettcs()}
            className={classes.textField2}
            
          />
           <TextField
            variant="standard"
            disabled
            label="Zoho Land"
            InputLabelProps={{ shrink: true }}
            value={getlandpart()}
            className={classes.textField2}
            
          />
          <TextField
            variant="standard"
            label="Cancellation fees"
            InputLabelProps={{ shrink: true }}
            value={tripData.high_tax_amount?tripData.high_tax_amount:0}
            onChange={(e)=>settripData({...tripData,high_tax_amount:parseInt(e.target.value)})}
            className={classes.textField2}
            
          />
          </div>):("")}
           
          <TextField
            disabled
            variant="standard"
            label="Total"
            InputLabelProps={{ shrink: true }}
            value={
              parseInt(tripData.flight_sp) +
              parseInt(tripData.visa_sp) +
              parseInt(tripData.anc_sp) +
              parseInt(tripData.extra_sp) +
              parseInt(tripData.cruise_sp) +
              parseInt(tripData.land_sp)+
              parseInt(tripData.high_tax_amount?tripData.high_tax_amount:0)+
              gettcs()
            }
            className={classes.textField2}
          />
        </FormGroup>
        {role=="Admin" || role=="Accounts" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product"?(
         <TextField variant="outlined"  label={"Payment Note"}  InputLabelProps={{ shrink: true }} disabled={tripData.trip_status=="Closed"?1:0} value={tripData.payment_note} className={classes.textAreanew} fullWidth multiline rows={2} onChange={(e)=> settripData({...tripData, payment_note: e.target.value})}/>
         ):("")}
        <form onSubmit={handleSubmit}>
          {cpdata.length>0 && cpdata.map((item) => {
            return (
              <div id="payment">
                <FormGroup row className={classes.formgroup}>
                <TextField
                    variant="standard"
                    disabled={1}
                    label="Tranche"
                    id={cpdata.indexOf(item)}
                   
                    value={cpdata.indexOf(item)}
                    className={classes.textField3}
                    
                  />
                  <TextField
                    variant="standard"
                    //disabled={allclear?1: (role=="Accounts"?0:(("status" in item && (item.status=="Received" || item.status=="Refund" || item.status=="Internal Refund"))?1:0))}
                    disabled={allclear?1:getdisabled("Date", item)}
                    required
                    label="Date"
                    helperText={"First payment date must match with Converted date otherwise SP will have incentive error"}
                    inputProps={{ max: (item.status=="Refund" || item.status=="Internal Refund")?null:fupfinalDate2 }}
                    id={cpdata.indexOf(item)}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={
                      item.date === undefined
                        ? ""
                        : item.date.split("T").slice(0, 1)
                    }
                    className={classes.textField}
                    onChange={(e) => datechange(e, e.target.id, item.id)}
                    
                  />
                  <TextField
                    variant="standard"
                    required
                    disabled={allclear?1:getdisabled("Amount", item)}
                    label="Amount (number)"
                    id={cpdata.indexOf(item)}
                    helperText={"no_tax" in tripData && tripData.no_tax?"This is a SPECIAL case":""}
                    value={item.amount}
                    className={classes.textField}
                    onChange={(e) => amountchange(e, e.target.id, item.id)}
                    onFocus={(e) => handleFocus(e.target.id, "CP-Amount")}
                    onBlur={(e) => handleBlur(e, e.target.id, item.id, "CP-Amount")}
                  />
             
                    <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="status">Status</InputLabel>
                    <Select
                      displayEmpty
                      disabled={allclear?1:getdisabled("Status", item)}
                      classname={classes.textField}
                      labelId="status"
                      required
                      name={cpdata.indexOf(item)}
                      value={item.status}
                      onChange={(e) => statuschange(e, e.target.name, item.id)}
                    >
                    <MenuItem value={"Pending"}>Pending</MenuItem>
                    <MenuItem value={"Received"}>Received</MenuItem>
                    <MenuItem value={"Refund"}>Refund</MenuItem>
                    <MenuItem value={"Internal Refund"}>Internal Refund</MenuItem>
                    <MenuItem value={"Credit Note"}>Credit Note</MenuItem>
                    <MenuItem value={"Waive Off"}>Waive Off</MenuItem>
                    <MenuItem value={"Paid to Supplier Directly"}>Paid to Supplier Directly</MenuItem> 
                    </Select>
                  </FormControl>
             
                   
                  
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="Mode">Mode</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="Mode"
                      name={cpdata.indexOf(item)}
                      disabled={allclear || (!(role=="Accounts") && "status" in item && item.status=="Received")}
                      value={item.mode}
                      onChange={(e) => modechange(e, e.target.name, item.id)}
                    >
                      <MenuItem value={""}>Clear</MenuItem>
                      <MenuItem value={"NEFT/RTGS"}>NEFT/RTGS</MenuItem>
                      <MenuItem value={"IMPS"}>IMPS</MenuItem>
                      <MenuItem value={"UPI"}>UPI</MenuItem>
                      <MenuItem value={"App"}>App</MenuItem>
                      <MenuItem value={"Cash"}>Cash</MenuItem>
                      <MenuItem value={"Others"}>Others</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="Account">Account</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="Account"
                      disabled={allclear || (!( role=="Accounts") && "status" in item && item.status=="Received")}
                      name={cpdata.indexOf(item)}
                      value={item.account}
                      onChange={(e) => accountchange(e, e.target.name, item.id)}
                    >
                      <MenuItem value={"Kotak"}>Kotak</MenuItem>
                      <MenuItem value={"AU"}>AU</MenuItem>
                      <MenuItem value={"Axis"}>Axis</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"IndusInd"}>IndusInd</MenuItem>
                      <MenuItem value={"HDFC"}>HDFC</MenuItem>
                      <MenuItem value={"SC-Hitesh"}>SC-Hitesh</MenuItem>
                      <MenuItem value={"SC-NitinK"}>SC-NitinK</MenuItem>
                      <MenuItem value={"SC-HarshB"}>SC-HarshB</MenuItem>
                      <MenuItem value={"SC-Yadvinder"}>SC-Yadvinder</MenuItem>
                      <MenuItem value={"SC-Qausain"}>SC-Qausain</MenuItem>
                      <MenuItem value={"SC-Rana"}>SC-Rana</MenuItem>
                      <MenuItem value={"SC-Sidharth"}>SC-Sidharth</MenuItem>
                      <MenuItem value={"SC-Abhishek"}>SC-Abhishek</MenuItem>
                      <MenuItem value={"SC-Amit"}>SC-Amit</MenuItem>
                      <MenuItem value={"SC-RohitS"}>SC-RohitS</MenuItem>
                      <MenuItem value={"SC-Pawan"}>SC-Pawan</MenuItem>
                      <MenuItem value={"SC-Debayan"}>SC-Debayan</MenuItem>
                      <MenuItem value={"Cash"}>Cash</MenuItem>
                      <MenuItem value={"Others"}>Others</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    variant="standard"
                    label="Details"
                    disabled={allclear}
                    id={cpdata.indexOf(item)}
                    value={item.details}
                    className={classes.textField}
                    onChange={(e) => detailschange(e, e.target.id, item.id)}
                  />
                </FormGroup>
                {item.status=="Pending"?(
                  <FormGroup row className={classes.formgroup}>
                <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={(e) => whatsapp(e, item.amount, item.date, item.id)}
            >Reminder 1
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={(e) => whatsapp(e, item.amount, item.date, item.id)}
            >Reminder 2
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={(e) => whatsapp(e, item.amount, item.date, item.id)}
            >Reminder 3
            </Button>
                </FormGroup>
                
                ):("")}
                
                <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={()=>addmid(cpdata.indexOf(item))}
            >
              {" "}
              + Tranche
            </Button>
            {role=="Accounts" || item.status=="Pending"?( <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={()=>removemid(item)}
            >
              {" "}
              - Tranche
            </Button>):("")}
           
          </FormGroup>
                <Typography
                  variant="h4"
                  align="center"
                  className={classes.headertext}
                >
                  {" "}
                  -------------------------------------------------------------------------------------------{" "}
                </Typography>
              </div>
            );
          })}

          
          <FormGroup row className={classes.formgroup}>
            <TextField
              variant="standard"
              type="Number"
              label="Flight Cost"
              InputLabelProps={{ shrink: true }}
              value={tripData.flight_cp}
              className={classes.textField2}
              onChange={(e) =>
                settripData({ ...tripData, flight_cp: e.target.value })
              }
            />
            <TextField
              variant="standard"
              type="Number"
              label="Visa Cost"
              InputLabelProps={{ shrink: true }}
              value={tripData.visa_cp}
              className={classes.textField2}
              onChange={(e) =>
                settripData({ ...tripData, visa_cp: e.target.value })
              }
            />
            <TextField
              variant="standard"
              type="Number"
              label="Ancilliary Cost"
              InputLabelProps={{ shrink: true }}
              value={tripData.anc_cp}
              className={classes.textField2}
              onChange={(e) =>
                settripData({ ...tripData, anc_cp: e.target.value })
              }
            />
            <TextField
            variant="standard"
            type="Number"
            label="AC/SIM/Insurance"
            InputLabelProps={{ shrink: true }}
            value={tripData.extra_cp}
            className={classes.textField2}
            onChange={(e) =>
              settripData({ ...tripData, extra_cp: e.target.value })
            }
          />
            <TextField
              variant="standard"
              type="Number"
              label="Cruise Cost"
              InputLabelProps={{ shrink: true }}
              value={tripData.cruise_cp}
              className={classes.textField2}
              onChange={(e) =>
                settripData({ ...tripData, cruise_cp: e.target.value })
              }
            />
            <TextField
              variant="standard"
              type="Number"
              label="Land Cost"
              InputLabelProps={{ shrink: true }}
              value={tripData.land_cp}
              className={classes.textField2}
              onChange={(e) =>
                settripData({ ...tripData, land_cp: e.target.value })
              }
            />
            <TextField
              disabled
              variant="standard"
              label="Total"
              InputLabelProps={{ shrink: true }}
              value={
                parseInt(tripData.flight_cp) +
                parseInt(tripData.visa_cp) +
                parseInt(tripData.anc_cp) +
                parseInt(tripData.extra_cp) +
                parseInt(tripData.cruise_cp) +
                parseInt(tripData.land_cp)
              }
              className={classes.textField2}
            />
          </FormGroup>

          <Typography
            variant="h4"
            align="center"
            className={classes.headertext}
          >
            {" "}
            Supplier Payments (Total:{sptotal()}) || (Pending:{sppending()})
          </Typography>
          {role=="Admin" || role=="Accounts" || role=="Support" || role=="Operations" || role=="Operations-TL" || role=="Product"?(
         <TextField variant="outlined"  label={"Ops Profit Note"}   disabled={tripData.trip_status=="Closed"?1:0} required={role=="Operations" || role=="Operations-TL"?1:0} InputLabelProps={{ shrink: true }} value={tripData.supplier_payment_note} className={classes.textAreanew} fullWidth multiline rows={2} onChange={(e)=> settripData({...tripData, supplier_payment_note: e.target.value})}/>
         ):("")}

          {spdata.map((item) => {
            return (
              <div>
                <FormGroup row className={classes.formgroup}>
                <TextField
                    variant="standard"
                    disabled={1}
                    label="Tranche"
                    id={spdata.indexOf(item)}
                   
                    value={spdata.indexOf(item)}
                    className={classes.textField3}
                    
                  />
                  <TextField
                    variant="standard"
                    disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"? item.all_good:1)}
                    label="Date"
                    required
                    id={spdata.indexOf(item)}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={
                      item.date === undefined
                        ? ""
                        : item.date.split("T").slice(0, 1)
                    }
                    
                    className={classes.textField}
                    onChange={(e) => spdatechange(e, e.target.id, item.id)}
                  />
                  <TextField
                    variant="standard"
                    disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                    label="Amount (number)"
                    InputLabelProps={{ shrink: true }}
                    required
                    id={spdata.indexOf(item)}
                    value={item.amount}
                    className={classes.textField}
                    onChange={(e) => spamountchange(e, e.target.id, item.id)}
                    onFocus={(e) => handleFocus(e.target.id, "SP-Amount")}
                    onBlur={(e) => handleBlur(e, e.target.id, item.id, "SP-Amount")}
                  />
                  {role=="Accounts"?(<div>
                    <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="status">Status *</InputLabel>
                    <Select
                      displayEmpty
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      classname={classes.textField}
                      labelId="status"
                      required
                      name={spdata.indexOf(item)}
                      value={item.status}
                      onChange={(e) =>
                        spstatuschange(e, e.target.name, item.id)
                      }
                    >
                      <MenuItem value={"Pending"}>Pending</MenuItem>
                      <MenuItem value={"Paid"}>Paid</MenuItem>
                      <MenuItem value={"Paid by internal team"}>Paid by internal team</MenuItem>
                      <MenuItem value={"Refund"}>Refund</MenuItem>
                      <MenuItem value={"Refund claim by internal team"}>Refund claim by internal team</MenuItem>
                      <MenuItem value={"Refund Due"}>Refund Due</MenuItem>
                      <MenuItem value={"Paid by client"}>Paid by client</MenuItem>  
                      <MenuItem value={"Forfeit"}>Forfeit</MenuItem>
                    </Select>
                  </FormControl>
                  </div>):(<div>
                 {!(role=="Admin" ) && "name" in item && item.name=="Not Booked Yet"?(<FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="status">Status *</InputLabel>
                    <Select
                      displayEmpty
                     disabled={ role=="Accounts"?0:(item.status=="Paid"?1:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1))}
                      classname={classes.textField}
                      labelId="status"
                      required
                      name={spdata.indexOf(item)}
                      value={item.status}
                      onChange={(e) =>
                        spstatuschange(e, e.target.name, item.id)
                      }
                    >
                      <MenuItem value={"Pending"}>Pending</MenuItem>
                      <MenuItem disabled value={"Paid"}>Paid</MenuItem>
                      <MenuItem disabled value={"Paid by internal team"}>Paid by internal team</MenuItem>
                      <MenuItem disabled value={"Refund"}>Refund</MenuItem>
                      <MenuItem value={"Refund claim by internal team"}>Refund claim by internal team</MenuItem>
                      <MenuItem value={"Refund Due"}>Refund Due</MenuItem>
                      <MenuItem disabled value={"Paid by client"}>Paid by client</MenuItem>  
                      <MenuItem disabled value={"Forfeit"}>Forfeit</MenuItem>
                     
                    </Select>
                  </FormControl>):(
                    <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="status">Status *</InputLabel>
                    <Select
                      displayEmpty
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      classname={classes.textField}
                      labelId="status"
                      required
                      name={spdata.indexOf(item)}
                      value={item.status}
                      onChange={(e) =>
                        spstatuschange(e, e.target.name, item.id)
                      }
                    >
                      <MenuItem value={"Pending"}>Pending</MenuItem>
                      <MenuItem disabled value={"Paid"}>Paid</MenuItem>
                      <MenuItem value={"Paid by internal team"}>Paid by internal team</MenuItem>
                      <MenuItem value={"Refund claim by internal team"}>Refund claim by internal team</MenuItem>
                      <MenuItem value={"Refund Due"}>Refund Due</MenuItem>
                      <MenuItem disabled value={"Refund"}>Refund</MenuItem>
                      <MenuItem value={"Paid by client"}>Paid by client</MenuItem>  
                      <MenuItem value={"Forfeit"}>Forfeit</MenuItem>
                    </Select>
                  </FormControl>)}
                  </div>)}
               
                  {role=="Admin" || role=="Accounts"?(
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="status">Invoice</InputLabel>
                    <Select
                      displayEmpty
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      classname={classes.textField}
                      labelId="status"
                      name={spdata.indexOf(item)}
                      value={item.invoice}
                      onChange={(e) =>
                        spinvoicechange(e, e.target.name, item.id)
                      }
                    >
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"No"}>No</MenuItem>
                      <MenuItem value={"NA"}>NA</MenuItem>
                       
                    </Select>
                  </FormControl>
                ):("")}
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="Mode">Mode</InputLabel>
                    <Select
                      displayEmpty
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      classname={classes.textField}
                      labelId="Mode"
                      name={spdata.indexOf(item)}
                      value={item.mode}
                      onChange={(e) => spmodechange(e, e.target.name, item.id)}
                    >
                      <MenuItem value={""}>Clear</MenuItem>
                      <MenuItem value={"NEFT/RTGS"}>NEFT/RTGS</MenuItem>
                      <MenuItem value={"IMPS"}>IMPS</MenuItem>
                      <MenuItem value={"UPI"}>UPI</MenuItem>
                      <MenuItem value={"App"}>App</MenuItem>
                      <MenuItem value={"Cash"}>Cash</MenuItem>
                      <MenuItem value={"NetBanking"}>NetBanking</MenuItem>
                      <MenuItem value={"Others"}>Others</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 240,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="Account">Account</InputLabel>
                    <Select
                      displayEmpty
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      classname={classes.textField}
                      labelId="Account"
                      name={spdata.indexOf(item)}
                      value={item.account}
                      onChange={(e) =>
                        spaccountchange(e, e.target.name, item.id)
                      }
                    >
                      <MenuItem value={"Kotak"}>Kotak</MenuItem>
                      <MenuItem value={"IndusInd"}>IndusInd</MenuItem>
                      <MenuItem value={"Axis"}>Axis</MenuItem>
                      <MenuItem value={"AU Bank"}>AU Bank</MenuItem>
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"HDFC"}>HDFC</MenuItem>
                      <MenuItem value={"SC-Hitesh"}>SC-Hitesh</MenuItem>
                      <MenuItem value={"SC-NitinK"}>SC-NitinK</MenuItem>
                      <MenuItem value={"SC-HarshB"}>SC-HarshB</MenuItem>
                      <MenuItem value={"SC-Yadvinder"}>SC-Yadvinder</MenuItem>
                      <MenuItem value={"SC-Qausain"}>SC-Qausain</MenuItem>
                      <MenuItem value={"SC-Rana"}>SC-Rana</MenuItem>
                      <MenuItem value={"SC-Sidharth"}>SC-Sidharth</MenuItem>
                      <MenuItem value={"SC-Abhishek"}>SC-Abhishek</MenuItem>
                      <MenuItem value={"SC-Amit"}>SC-Amit</MenuItem>
                      <MenuItem value={"SC-RohitS"}>SC-RohitS</MenuItem>
                      <MenuItem value={"SC-Pawan"}>SC-Pawan</MenuItem>
                      <MenuItem value={"SC-Debayan"}>SC-Debayan</MenuItem>
                      <MenuItem value={"Cash"}>Cash</MenuItem>
                      <MenuItem value={"Others"}>Others</MenuItem>
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 180,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="Currency">Currency</InputLabel>
                    <Select
                      displayEmpty
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      classname={classes.textField}
                      labelId="Currency"
                      name={spdata.indexOf(item)}
                      value={item.currency}
                      onChange={(e) =>
                        currencychange(e, e.target.name, item.id)
                      }
                    >
                      <MenuItem value={"INR"}>INR</MenuItem>
                      <MenuItem value={"USD"}>USD</MenuItem>
                      <MenuItem value={"EUR"}>EUR</MenuItem>
                      <MenuItem value={"THB"}>THB</MenuItem>
                      <MenuItem value={"AED"}>AED</MenuItem>
                      <MenuItem value={"IDR"}>IDR</MenuItem>
                      <MenuItem value={"SGD"}>SGD</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                  
                  InputLabelProps={{ shrink: true }}
                    variant="standard"
                    disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                    label="Value in Currency"
                    id={spdata.indexOf(item)}
                    value={item.currency_value}
                    className={classes.textFieldnew}
                    onChange={(e) => currencyvaluechange(e, e.target.id, item.id)}
                    onFocus={(e) => handleFocus(e.target.id, "SP-Value")}
                    onBlur={(e) => handleBlur(e, e.target.id, item.id, "SP-Value")}
                  />
                  <TextField
                  InputLabelProps={{ shrink: true }}
                    variant="standard"
                    disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                    label="Details"
                    id={spdata.indexOf(item)}
                    value={item.details}
                    className={classes.textField}
                    onChange={(e) => spdetailschange(e, e.target.id, item.id)}
                    onFocus={(e) => handleFocus(e.target.id, "SP-Details")}
                    onBlur={(e) => handleBlur(e, e.target.id, item.id,"SP-Details")}
                  />
                </FormGroup>

                <FormGroup row className={classes.formgroup}>
                {/* <Autocomplete
                    //disablePortal
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                    id="combo-box-demo"
                    options={sData}
                    classname={classes.textField}
                    getOptionLabel={(option) => option.supplier_name}
                    groupBy={(option) => option.supplier_type}
                    renderInput={(params) => <TextField {...params} label="Supplier" />}
                    value={item.name}
                    inputValue={item.name}
                    //onInputChange={(e) => spnamechange(e, spdata.indexOf(item), item.id)}
                    onChange={(e) => spnamechange(e, spdata.indexOf(item), item.id)}
                    />  */}
                  <FormControl
                    style={{
                      minWidth: 360,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="supplier">Supplier</InputLabel>
                    <Select
                      displayEmpty
                      classname={classes.textField}
                      labelId="supplier"
                      disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"?item.all_good:1)}
                      name={spdata.indexOf(item)}
                      value={item.name}
                      helperText={"ABC"}
                      onChange={(e) => spnamechange(e, e.target.name, item.id)}
                    >
                    <ListSubheader>DMC</ListSubheader>
                    {sData.filter(s=>s.supplier_type=="DMC").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Hotel</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Hotel").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Hotel Portal</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Hotel Portal").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Flight</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Flight").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Flight Ancilliary</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Flight Ancilliary").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Visa agency</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Visa agency").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Cab driver</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Cab driver").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Cab agency</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Cab agency").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Restaurant</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Restaurant").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Insurance agency</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Insurance agency").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                      <ListSubheader>Others</ListSubheader>
                      {sData.filter(s=>s.supplier_type=="Others").map((sup) => {
                        return (
                       
                            <MenuItem value={sup.supplier_name}>
                            {sup.supplier_name}
                          </MenuItem>
                         
                          
                        );
                      })}
                     
                      
                    </Select>
                    <FormHelperText>{getpaymentrule(item.name)}</FormHelperText>
                  </FormControl>
                   <Button
              variant="contained"
              color="primary"
              onClick={()=>checknumberbooking(item.name)}
              className={classes.button}
            >
              Check
            </Button>
                  <TextField
            variant="standard"
           
            label="Supplier Type"
            InputLabelProps={{ shrink: true }}
            value={item.name?getsuppliertype(item.name):""}
            className={classes.textField2}
            disabled
          />
          
              {/* <TextField
                  InputLabelProps={{ shrink: true }}
                    variant="standard"
                    required={item.name && getsuppliertype(item.name)=="FLight"?1:0}
                    label="Airlines"
                    id={spdata.indexOf(item)}
                    value={item.airline_name}
                    className={classes.textField}
                    onChange={(e) => spairlinechange(e, e.target.id, item.id)}
                  />  */}
                  {item && item.name && getsuppliertype(item.name)=="Flight"?(
                  <FormControl
                      style={{
                        minWidth: 160,
                        marginTop: 16,
                        marginRight: 32,
                        marginLeft: 32,
                      }}
                    >
                      <InputLabel>Airline</InputLabel>
                      <Select
                        displayEmpty
                        classname={classes.textField}
                        labelId="airline"
                        variant="standard"
                        name={spdata.indexOf(item)}
                        value={item.airline_name}
                        onChange={(e) => spairlinechange(e, e.target.name, item.id)}
                      >
                      <MenuItem value="">Clear</MenuItem>
                       {airlinelist2.map((airline)=>
                       <MenuItem value={airline}>{airline}</MenuItem>
                        )}
                       
                      </Select>
                    </FormControl> ):(
                      <TextField
                    variant="standard"
                    disabled={ role=="Accounts"?0:(role=="Admin" || role=="Operations" || role=="Operations-TL" || role=="Product"? item.all_good:1)}
                    label="Booking Date"
                    required={role=="Operations-TL" || role=="Operations"?1:0}
                    id={spdata.indexOf(item)}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={
                      item.booking_date === undefined
                        ? ""
                        : (new Date(item.booking_date).toISOString()).split("T").slice(0, 1)
                    }
                    
                    className={classes.textFieldnew}
                    onChange={(e) => spbookingdatechange(e, e.target.id, item.id)}
                  />
                    )}
                   <TextField
                    variant="standard"
                    disabled={role=="Admin" || role=="Operations"   || role=="Product" || role=="Operations-TL"?0:1}
                    label="Cut Off Date"
                  
                    id={spdata.indexOf(item)}
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={
                      item.cut_off === undefined ||  item.cut_off===null
                        ? ""
                        : item.cut_off.split("T").slice(0, 1)
                    }
                    
                    className={classes.textFieldnew}
                    onChange={(e) => spcutoffchange(e, e.target.id, item.id)}
                  />   
                  
                </FormGroup>
                <FormGroup row className={classes.formgroup}>
                
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="responsible">Responsible</InputLabel>
                    <Select
                      displayEmpty
                      disabled={role=="Operations" || role=="Operations-TL" || role=="Admin"?("reponsible" in item?(item.responsible==cuser?0:1):0):1}
                      required={(role =="Admin" || role=="Accounts" || role=="Product")?1:0}
                      classname={classes.textField}
                      labelId="responsible"
                      name={spdata.indexOf(item)}
                      value={item.responsible}
                      onChange={(e) => responsiblechange(e, e.target.name, item.id)}
                    >
                     {empops.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
                     
                      
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minWidth: 480,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 8,
                    }}
                  >
                    <InputLabel id="checker">Checker</InputLabel>
                    <Select
                      displayEmpty
                      disabled={role=="Admin"?0:(role=="Operations" || role=="Operations-TL"?("checker" in item?(item.responsible==cuser || role=="Operations-TL"?0:1):0):0)}
                      required={(role =="Admin" || role=="Accounts" || role=="Product")?1:0}
                      classname={classes.textField}
                      labelId="checker"
                      name={spdata.indexOf(item)}
                      value={item.checker}
                      onChange={(e) => checkerchange(e, e.target.name, item.id)}
                    >
                     {empops.map((emp) => {
                return <MenuItem value={emp}>{emp}</MenuItem>;
              })}
                     
                      
                    </Select>
                  </FormControl>
                  <FormControlLabel control={<Checkbox color="primary"/>}  name={spdata.indexOf(item)} value={item.all_good} checked={item.all_good} label="Double Checked?"  onChange={(e) => doublecheckchange(e, e.target.name, item.id)} disabled={item.checker==cuser || role=="Admin"?0:1}/>
                  <FormControlLabel control={<Checkbox color="primary"/>}  name={spdata.indexOf(item)} value={item.pna} checked={item.pna} label="Passport?Name/Age?"  onChange={(e) => pnachange(e, e.target.name, item.id)} />
                </FormGroup>
                <Typography
                  variant="h4"
                  align="center"
                  className={classes.headertext}
                >
                  {" "}
                  -------------------------------------------------------------------------------------------{" "}
                </Typography>
              </div>
            );
          })}

           <FormGroup row className={classes.formgroup}>
            <Button
              variant="outlined"
              color="primary"
              className={classes.button}
              onClick={addsp}
            >
              {" "}
              + Tranche
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              className={classes.button}
              onClick={removesp}
            >
              {" "}
              - Tranche
            </Button>
          </FormGroup>
          <br></br>
          <br></br>
          <hr></hr>
          <br></br>
          <br></br>

        
{role=="Admin" || role=="Manager" || role=="TL" || role=="SME" || role=="Accounts" || role=="Operations" || role=="Support" || role=="Operations-TL" || role=="Product"?(
  <FormGroup row className={classes.formgroup}>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className={classes.button}
            >
              Save
            </Button>
            <Button
              href={"/tripdataentry/" + currentid}
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              Cancel
            </Button>
          </FormGroup>
):(<div></div>)}
          
        </form>
        {role=="Admin"?"Hold Ops Date: "+tripData.hold_ops_date:""}
      </Paper>
      ):("Loading...")}
    </div>
  );
};

export default Trippaymentupdate;
